import React, { useState, useEffect, Fragment, useContext, useRef } from "react";
import axios from "axios";
import { BsTelephoneFill } from "react-icons/bs";
import { MdMail } from "react-icons/md"
import { RiFileCopy2Fill } from "react-icons/ri"
import { logDOM } from "@testing-library/react";
import { FormatCreditCard, FormatExpirationDate, capitalizeSentence, copyClipbord, formatCOPNumber, formatCOPNumberInput, formatDocument, formatPhoneNumber, getDigits, getDigitsRegister, getFranchise, getNavInfo, getPaymentDeviceNote, isAPhone, isBitppi72342403Profile, isBitppiAxiUser, millisecondsToMinutesAndSeconds, swapArrayElements, validateName } from "../functions";
import _, { values } from 'lodash'
import QRCode from "react-qr-code";
import { QRCode as QRCode_ } from 'react-qrcode-logo';

import Loading from '../components/Loading';
import { Carousel } from "../components/Carousel";
import PinPayInfo from "../components/PinPayInfo";
import ListItem from "../components/ListItem";
import Modal from "../components/Modal";
import checkIcon from '../assets/icons/check-icon.png'
import SelectModal from "../components/SelectModal";
import moment from "moment";
import { countries_new } from "../constants";
import NavBarCobru from "../components/NavBarCobru";
import Input from "../components/Input";
import SplitAmount from "../components/SplitAmount";
import useRecaptcha from "../hooks/useRecaptcha";
import ReCAPTCHA from "react-google-recaptcha";
import { MainContext } from "../contexts/MainContext";
import { useNavigate, useLocation } from 'react-router-dom';
import Slider from "../components/Slider";
import CobruNavBar from "../components/CobruNavBar";
import { useLanguage } from "../contexts/LanguageContext";
import Translate from "../components/Translate";
import EmailContact from "../components/EmailContact";
import PhoneContact from "../components/PhoneContact";
import UserNameComponent from "../components/UserNameComponent";
import { useGeo } from "../contexts/GeoContext";
import tronLogo from '../assets/tron-logo.png'
import ethLogo from '../assets/ethereum-eth-logo.png'
import polygonLogo from '../assets/polygon-icon.png'
import { process3DS } from "../helpers/epayco";
import breb_icon from '../assets/bre-b.png'
import Toast from "../components/Toast";
import Modal2 from "../components/Modal2";
import { getTengoCarouselMethods, getTengoCryptoNetworks, parseTengoUsdAmount } from '../helpers/tengoPaymentMethods';


function Home(props) {
  const AXI_ACCENT = '#ff3f52';
  //const isEzy = window?.location?.hostname === 'link.ezytransfer.co' ? true : false
  //const isPagaHoy = window?.location?.hostname === 'link.pagahoy.com' ? true : false

  const location = useLocation();
  const navigate = useNavigate();
  const { setLanguage, translate } = useLanguage();
  const { countryFull } = useGeo()
  const { methods, selectedMethod, cobruURL: cobruURLFromState, cobru, params, isAPhoneNumber } = location?.state
  const stripBrandPrefixFromCobruURL = (value) => {
    if (!value) return value;
    const s = String(value);
    // Quita el prefijo "BRAND-" (corta solo en el primer guion)
    // Ej: "COLOCA-hdfskjdfh" -> "hdfskjdfh"
    // Ej: "COLOCA-EXT-xxxx" -> "EXT-xxxx" (mantiene el resto intacto)
    const idx = s.indexOf('-');
    return idx > 0 ? s.slice(idx + 1) : s;
  };
  const cobruURL = stripBrandPrefixFromCobruURL(cobruURLFromState);
  const rawCobruURL = cobruURLFromState ? String(cobruURLFromState).trim() : '';
  const isBitppi72342403Layout =
    (cobruURL === '72342403' &&
      (rawCobruURL === '72342403' || /^(BITPPI|BITTPI)-72342403$/i.test(rawCobruURL))) ||
    isBitppi72342403Profile(cobru);
  console.log(params);
  const { isCaptchaValid, setIsCaptchaValid, showRecaptcha, setShowRecaptcha, globalCurrency, setGlobalCurrency,
    isEzy, isPagaHoy, isTucanPay, isDev, getActiveVariableBrand, getBrandAccentColor, isBitppi, isTengo } = useContext(MainContext);
  const isTengoPayment = isTengo || String(cobru?.brand || '').toUpperCase() === 'TENGO';
  const isBitppiAxi = isBitppiAxiUser(cobruURL, getActiveVariableBrand());
  const secondsFromMMSS = (value) => {
    if (!value || typeof value !== 'string') return null;
    const parts = value.split(':');
    if (parts.length !== 2) return null;
    const m = Number(parts[0]);
    const s = Number(parts[1]);
    if (!Number.isFinite(m) || !Number.isFinite(s)) return null;
    return (m * 60) + s;
  };
  const [activated, setActivate] = useState(false)
  const [paymentsMethod, setPaymentsMethod] = useState(methods || null)
  const [payMethodName, setPayMethodName] = useState(null)
  const [loading, setLoading] = useState(false)
  const [paymentsMethodArray, setPaymentsMethodArray] = useState([])
  const [currentPaymentMethod, setCurrentPaymentMethod] = useState(null)
  const [showCobru, setShowCobru] = useState(true)
  const [formValues, setFormValues] = useState({
    name: '',
    docType: '',
    doc: '',
    email: '',
    phone: '',
    //amount: ''
  })
  const [showCanceledModal, setShowCanceledModal] = useState(false);

  const [errorMessages, setErrorMessages] = useState({
    amount: '',
    name: '',
    docType: '',
    doc: '',
    email: '',
    phone: '',
    //amount: ''
  })
  /*     const [formValues, setFormValues] = useState({
          name: 'Angel Rodriguez',
          docType: '1',
          doc: '1001855422',
          email: 'angel@prueba.com',
          phone: '3160497786'
      }) */
  const [creditCardNumber, setCreditCardNumber] = useState('')
  const [OTPNumber, setOTPNumber] = useState('')
  const [creditCardDate, setCreditCardDate] = useState('')
  const [creditCardCVV, setCreditCardCVV] = useState('')
  const [creditCardCuotas, setCreditCardCuotas] = useState({ id: 1, label: '1 Cuota', value: '1' })
  const [expDate, setExpDate] = useState('')
  const [showForm, setShowForm] = useState(true)
  const [showQr, setShowQr] = useState(false)
  const [successCheck, setSuccessCheck] = useState(false)
  const [showPin, setShowPin] = useState(false)
  const [currencyWallet, setCurrencyWallet] = useState('')
  const [brebStatus, setBrebStatus] = useState(null);

  const [qrValue, setQrValue] = useState(null)
  const [waitingNequiPay, setWaitingNequiPay] = useState(false)
  const [paymentDetails, setPaymentDetails] = useState({})
  const [paymentDetailsCobru, setPaymentDetailsCobru] = useState({})

  const [payPin, setPayPin] = useState({ code: '', ref: '' })
  const [countDown, setCountDown] = useState('00:00')
  const brebSecondsLeft = secondsFromMMSS(countDown);
  const cryptoSecondsLeft = secondsFromMMSS(countDown);
  const [countDowDaviplata, setCountDownDaviplata] = useState('00:00')
  const [runTimerCheck, setRunTimerCheck] = useState(null)
  const [runTimerCheckDaviplata, setRunTimerCheckDaviplata] = useState(null)
  const [runTimerCheckBreb, setRunTimerCheckBreb] = useState(null)
  const [currencyAmount, setCurrencyAmount] = useState('Calculando...')
  const [cryptoInterval, setCryptoInterval] = useState(null)
  const [intervalBREB, setIntervalBREB] = useState(null)
  const [daviplataInterval, setDaviplataInterval] = useState(null)
  const [bankList, setBankList] = useState([])
  const [amount, setAmount] = useState('')
  const [bankPse, setBankPse] = useState({ value: '', label: translate('select_bank_label') })
  const [showModal, setShowModal] = useState(false)
  // Red/activo para pagos cripto cuando el método seleccionado es "USDT"
  // El backend espera que `payment` cambie a USDT / ETH / POLYGON.
  const [cryptoNetwork, setCryptoNetwork] = useState('USDT');
  const [errorMessage, setErrorMessage] = useState('')
  const [buttonName, setButtonName] = useState('')
  // Rate limit (ej: COBRU_OUT_RATE_LIMIT_TRX)
  const [rateLimitSeconds, setRateLimitSeconds] = useState(0);
  const rateLimitIntervalRef = useRef(null);
  const [country, setCountry] = useState(
    { id: 0, label: 'Seleccionar', value: '', label2: '' },
  )
  const [item_, setItem_] = useState(null)
  const [showOTP, setShowOTP] = useState(false)
  //const [showOTPDaviplata, setShowOTPDaviplata] = useState(false)
  const [cobruItem, setCobruItem] = useState(false)
  const [cobruItemBack, setCobruItemBack] = useState(false)
  const [isPhoneNumber, setIsPhoneNumber] = useState(false)
  const shouldCreateCobru = Boolean(isPhoneNumber || isAPhoneNumber);
  const [cobruURL_, setCobruURL_] = useState('')
  const createdCobruURLRef = useRef('')
  const [daviplataInfo, setDaviplataInfo] = useState(null)
  const [trm, setTrm] = useState(null)
  const [isInt, setIsInt] = useState(false)
  const [description, setDescription] = useState('')
  const [amountOptions, setAmountOptions] = useState([
    { label: 'COP', value: 'COP' },
    { label: 'USD', value: 'USD' },
  ])
  const [error, setError] = useState('')
  const [quantity, setQuantity] = useState(1)
  const [showPhoneCobru, setShowPhoneCobru] = useState(false)
  const [toast, setToast] = useState(null);
  const [walletCopied, setWalletCopied] = useState(false);
  const walletCopiedTimeoutRef = useRef(null);
  const isGateway24 = Number(cobru?.owner_gateway) === 24;
  // Refs to avoid stale state inside Bre-B timer interval
  const runTimerBrebRef = useRef(false);
  const brebStatusRef = useRef(null);
  const paymentDetailsRef = useRef(null);
  const payerLocationRef = useRef(null);
  const payerLocationRequestedRef = useRef(false);
  // Nuevo: ref para USDT timer
  const runTimerCheckRef = useRef(false);
  const cryptoIntervalRef = useRef(null);
  // Evita que respuestas viejas pisen el QR actual al cambiar de tab
  const cryptoDetailsRequestIdRef = useRef(0);
  // Debounce al cambiar de red USDT/ETH/POLYGON: espera antes de llamar a getDetailsPay
  const usdtNetworkSwitchIdRef = useRef(0);
  const usdtNetworkSwitchTimeoutRef = useRef(null);
  // Mantiene mínimo 3s entre llamadas a getDetailsPay al cambiar de red (pero no “suma” esperas)
  const nextCryptoGetDetailsAllowedAtRef = useRef(0);
  const CRYPTO_GET_DETAILS_MIN_GAP_MS = 3000;

  const requestPayerLocation = () => {
    if (payerLocationRequestedRef.current) {
      return Promise.resolve(payerLocationRef.current);
    }

    payerLocationRequestedRef.current = true;

    if (!navigator.geolocation) {
      return Promise.resolve(null);
    }

    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          const payerLocation = {
            latitude: coords.latitude,
            longitude: coords.longitude
          };
          payerLocationRef.current = payerLocation;
          resolve(payerLocation);
        },
        () => resolve(null),
        {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 300000
        }
      );
    });
  };
  //const [amountOption, setAmountOption] = useState('COP')
  //const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  //const [showRecaptcha, setShowRecaptcha] = useState(false)

  /*  const [documentItem, setDocumentItem] = useState(
       { id: 0, label: 'Seleccionar', value: '' },
 
   ) */

  const [loadingIpInfo, setLoadingIpInfo] = useState(false)
  const { recaptchaValue } = useRecaptcha();

  const documentTypesArray = [
    { id: 0, label: translate('select_label'), value: '' },
    {
      label: `CC - Cédula de ciudadanía`,
      label2: "CC",
      value: 0,
    },
    {
      label: `CE - Cédula de extranjería`,
      label2: "CE",
      value: 1,
    },
    {
      label: `TI - Tarjeta de identidad`,
      label2: "TI",
      value: 2,
    },
    {
      label: `NIT`,
      label2: "NIT",
      value: 3,
    }
  ]
  const [documentTypes, setDocumentTypes] = useState(documentTypesArray)
  const [documentItem, setDocumentItem] = useState(documentTypesArray[1])
  const fullNamePlaceholder = isBitppi72342403Layout ? 'Client Name' : translate("full_name_label");
  const documentNumberPlaceholder = isBitppi72342403Layout ? 'Client account number' : translate("id_number");
  const emailPlaceholder = isBitppi72342403Layout ? 'Email' : translate("email_label");
  const nameErrorMessage = isBitppi72342403Layout ? 'Client Name inválido' : translate('name_error');
  const documentErrorMessage = isBitppi72342403Layout ? 'Client account number inválido' : translate('document_number_error');
  const emailErrorMessage = isBitppi72342403Layout ? 'Email inválido' : translate('email_error');
  const displayedButtonName = payMethodName === 'USDT'
    ? translate('pay_with') + (isTengoPayment ? cryptoNetwork : 'USDT')
    : buttonName;
  const getBitppiProfileFormValues = () => ({
    name: params?.name || '',
    docType: params?.doc_type?.toString() || '',
    doc: params?.doc_number
      ? formatDocument(params.doc_number.toString())
      : '',
    email: params?.email || '',
    phone: params?.phone
      ? formatPhoneNumber(params.phone.toString())
      : '',
  });
  const hasPrefilledBitppiField = (paramValue) =>
    isBitppi72342403Layout && !!paramValue;
  const getCuotasArray = () => {
    let cuotas = [{ id: 1, label: `1 ${translate('dues_label')}`, value: '1' }]
    for (let index = 1; index < 36; index++) {
      cuotas[index] = { id: index + 1, label: `${index + 1} ${translate('dues_label')}`, value: index + 1 };
    }
    return cuotas
  }
  let cuotas = getCuotasArray()
  //let cuotasEnglish = getCuotasArrayEnglish()
  /* const getCuotasArrayEnglish = () => {
      let cuotas = [{ id: 1, label: `1 ${translate('dues_label')}`, value: '1' }]
      for (let index = 1; index < 36; index++) {
          cuotas[index] = { id: index + 1, label: `${index + 1} Dues`, value: index + 1 };
      }
      return cuotas
  } */
  const showToast = () => {
    setToast({
      message: "Copiado! 📄",
      type: "success"
    });
  }
  const handleRecaptchaChange = (response) => {
    // Esta función se llama cuando el reCAPTCHA se completa
    // Puedes validar el reCAPTCHA aquí y actualizar el estado
    // para indicar si es válido o no
    //console.log(response);
    setIsCaptchaValid(!!response);
  }
  const onSubmitRecaptchaValue = async () => {
    if (isCaptchaValid) {
      return true
    }
    //setShowRecaptcha(false)
    if (recaptchaValue) {
      const res = await axios.post('/verificar-recaptcha', { recaptchaToken: recaptchaValue });
      if (res?.status == 200 && res?.data) {
        if (res?.data?.success === true) {
          setIsCaptchaValid(true)
        }
        return res?.data?.success
      } else {
        setIsCaptchaValid(false)
        return false
      }
      //console.log('recaptchaValue', res);
      // Realiza la acción que necesites aquí, como enviar la solicitud al servidor.
      console.log("Puntuación de reCAPTCHA:", recaptchaValue);
    } else {
      setIsCaptchaValid(false)
      return false
      setShowRecaptcha(true)
      console.error("Por favor, completa la verificación reCAPTCHA.");
    }
  }
  useEffect(() => {
    if (!toast) return;

    const timer = setTimeout(() => setToast(null), 3000);
    return () => clearTimeout(timer);
  }, [toast]);

  useEffect(() => {
    setWalletCopied(false);
    if (walletCopiedTimeoutRef.current) {
      clearTimeout(walletCopiedTimeoutRef.current);
      walletCopiedTimeoutRef.current = null;
    }
  }, [qrValue]);

  useEffect(() => {
    return () => {
      if (walletCopiedTimeoutRef.current) {
        clearTimeout(walletCopiedTimeoutRef.current);
      }
    };
  }, []);

  //ldqdt7ye
  useEffect(() => {
    if (!!cobruURL) {
      setCobruURL_(cobruURL)

    }
  }, [cobruURL])
  useEffect(() => {
    if (cobru) {
      setCobruItem(cobru)

    }
  }, [cobru])
  useEffect(() => {
    if (isAPhoneNumber) {
      setIsPhoneNumber(isAPhoneNumber)

    }
  }, [isAPhoneNumber])
  useEffect(() => {
    // Buscar Colombia como fallback
    const defaultCountry = countries_new.find(e => e.code === "CO");

    if (isBitppi72342403Layout && params?.country_code) {
      const rawCountryCode = String(params.country_code).trim().toUpperCase();
      const countryFromParam = countries_new.find(e =>
        e.code === rawCountryCode ||
        e.indicative === parseInt(rawCountryCode.replace('+', ''), 10)
      );
      setCountry(countryFromParam || defaultCountry);
      return;
    }

    if (!countryFull || !countryFull.country_calling_code || !countryFull.country_code) {
      setCountry(defaultCountry); // Si falta info, usar Colombia
      return;
    }

    try {
      const indicative = parseInt(countryFull.country_calling_code.replace('+', ''), 10);

      // Filtrar todos los países con el mismo código de llamada
      const matches = countries_new.filter(e => e.indicative === indicative);

      let selectedCountry = matches.find(e => e.code === countryFull.country_code) || matches[0];

      // Si no encuentra coincidencias, usar Colombia por defecto
      setCountry(selectedCountry || defaultCountry);
    } catch (error) {
      console.error("Error al procesar el país:", error);
      setCountry(defaultCountry);
    }
  }, [countryFull, isBitppi72342403Layout, params?.country_code]);


  useEffect(() => {
    if (!!paymentsMethod) {
      formatPayment()

    }
  }, [paymentsMethod])

  useEffect(() => {
    if (!!params) {
      setLanguage(params?.language === 'en' ? 'en' : 'es');
      fillFields()
      fillUrl()
      if (params?.int === 'true') {

        setCreditCardCuotas({ id: 1, label: '1 Due', value: '1' })
      }

    }
  }, [params])

  useEffect(() => {
    if (paymentsMethodArray && currentPaymentMethod) {
      swapArrayElements_()
    }
  }, [paymentsMethodArray])

  useEffect(() => {
    try {
      if (!!currentPaymentMethod) {
        let name = Object.keys(currentPaymentMethod?.name)[0]
        setPayMethodName(name)
      }

    } catch (error) {
      console.log(error);
    }
  }, [currentPaymentMethod])

  useEffect(() => {
    getBankList()
  }, [])

  useEffect(() => {
    getTRM()
  }, [])

  useEffect(() => {
    if ((!!params && params?.int === 'true') && (payMethodName === 'credit_card' || payMethodName === 'USDT') && !!cobru) {
      setFormValues({
        name: '',
        docType: '',
        doc: '',
        email: '',
        phone: '',
        //amount: ''
      })
      console.log('acaxddddd');
      if (isBitppi72342403Layout) {
        setFormValues(getBitppiProfileFormValues());
        return;
      }
      let arrayNew = [...documentTypesArray, {
        label: `PA - Pasaporte`,
        label2: "PA",
        value: 4,
      },
      {
        label: `PPT - Permiso de Protección Temporal`,
        label2: "PPT",
        value: 5,
      }]
      console.log('cobru', cobru?.owner_document_type);
      let item_ = null
      if (cobru) {
        //alert('OK')
        item_ = arrayNew.find(e => e.value.toString() === cobru?.owner_document_type.toString())
        console.log('item_: ', item_);
        setDocumentItem(item_)
      }

      let name = cobru?.alias
      let palabras = cobru?.alias?.split(' ');
      if (!!params && params?.int === 'true') {
        if (palabras.length < 2) {
          name = `${cobru?.alias} ${cobru?.alias}`
        }
      }
      setFormValues({
        name: name || '',
        docType: item_?.value.toString() || '',
        //docType:item_?.id || '',
        doc: cobru?.owner_document || '',
        email: cobru?.owner_email || '',
        phone: cobru?.phone ? formatPhoneNumber(cobru?.phone.toString()) : '',

      })
      console.log(cobru);

      console.log('usee', {
        name: name || '',
        docType: item_?.value.toString() || '',
        doc: cobru?.owner_document || '',
        email: cobru?.owner_email || '',
        phone: cobru?.phone ? formatPhoneNumber(cobru?.phone.toString()) : '',

      });
    }
  }, [params, payMethodName])

  useEffect(() => {
    if (cryptoInterval) {
      clearInterval(cryptoInterval);
    }

    return () => {
      if (cryptoInterval) {
        clearInterval(cryptoInterval);
      }
    }
  }, [])
  useEffect(() => {
    if (daviplataInterval) {
      clearInterval(daviplataInterval);
    }
    //clear interval ()
    /* return () => {
        if (daviplataInterval) {
            clearInterval(daviplataInterval);
        }
    } */
  }, [])

  //console.log('REACT_APP_RECAPTCHA_KEY: ',process.env.REACT_APP_RECAPTCHA_KEY);

  /* useEffect(() => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_KEY}`;
      script.async = true;
      document.body.appendChild(script);
  }, []); */

  const USDPayments = () => {
    if (payMethodName === 'USDT' || payMethodName === 'safetypay' || payMethodName === 'credit_card') {
      return true
    }
  }
  const formatPayment = () => {
    let array = []
    let paymentsMethod_ = []
    for (var key in paymentsMethod) {
      if (paymentsMethod.hasOwnProperty(key)) {
        if (paymentsMethod[key] === true) {
          paymentsMethod_.push(key)
        }
      }
    }
    if (isTengoPayment) {
      paymentsMethod_ = getTengoCarouselMethods(paymentsMethod);
    } else {
      // ETH y POLYGON son redes dentro de la opción cripto.
      const excludedPaymentMethods = new Set(['polygon', 'eth'])
      paymentsMethod_ = paymentsMethod_.filter((k) => !excludedPaymentMethods.has(String(k).toLowerCase()))
    }
    console.log(paymentsMethod_);
    /* Object.keys(paymentsMethod).map((item, i) => {
        array.push({ [item]: item === item || false, index: i, name: { [item]: item === item }, available:(item === item || false ) })
    }) */
    paymentsMethod_.map((item, i) => {
      array.push({ [item]: item === item || false, index: i, name: { [item]: item === item }, available: (item === item || false) })
    })
    //
    // Método seleccionado (si existe) dentro del array final
    const selectedKey = selectedMethod ? Object.keys(selectedMethod)[0] : null;
    let item_ = selectedKey ? (array.find((it) => it?.name?.[selectedKey]) || null) : null;
    console.log('array: ', array, array[0]?.index, item_?.index);
    if (!isTengoPayment && !!params && params?.int === 'true') {

      /* if (array.length > 0 && item_) {
          array = array.filter(item => {
              const paymentMethods = ['credit_card', 'USDT'];
              return paymentMethods.includes(Object.keys(item.name)[0]);
          });
      } */
      if (array.length > 0 && item_) {
        const paymentMethods = ['credit_card', 'USDT'];

        array = array
          .filter(item => paymentMethods.includes(Object.keys(item.name)[0]))
          .sort((a, b) => {
            return Object.keys(a.name)[0] === 'credit_card' ? -1 : 1;
          });
      }
      setPaymentsMethodArray(array)
      setCurrentPaymentMethod(array[0] || null)
      onChangeBTNName(array[0] || null)
      return
    }
    // Si solo hay 1 método, se selecciona automáticamente
    if (array.length === 1) {
      setPaymentsMethodArray(array);
      setCurrentPaymentMethod(array[0]);
      onChangeBTNName(array[0]);
      return;
    }

    // Si hay un método preseleccionado, reordena para que quede primero
    if (array.length > 0 && item_ && typeof item_?.index === 'number' && item_.index !== 0) {
      swapArrayElements(array, 0, item_.index);
      console.log('aca', array, 0, item_.index);
    }
    setPaymentsMethodArray(array)
    setCurrentPaymentMethod(item_ || array[0] || null)
    console.log('setPaymentsMethodArray', array);
    onChangeBTNName(item_ || array[0] || null)

  }

  const swapArrayElements_ = async () => {

  }

  const validateMaxMinUSD = async (amount_ = '') => {
    if (!!params && params?.language) {
      setLanguage(params?.language === 'en' ? 'en' : 'es');
    }

    /* if (!!params && params?.isInt === 'true') {
        setLanguage('en')

    } */
    let amount_new = amount_ ? amount_ : amount ? amount : ''
    console.log(amount_new);
    if (globalCurrency === 'USD' || (!!params && params?.currency?.toString()?.toLowerCase() === 'usd')) {
      //alert('ok')
      /*  console.log(getDigitsRegister(amount_new));
       console.log( (parseFloat(getDigitsRegister(amount_new)) * parseFloat(trm))/parseFloat(trm));
       console.log( cobru?.max /trm);
       console.log(parseFloat(getDigitsRegister(amount_new)) / parseFloat(trm)); */
      let trmNew = null
      if (!trm) {
        const res = await axios.post('/getSwapMoney', { amount: '10000' });
        if (res?.data?.data && res?.status === 200) {
          trmNew = res?.data?.data?.price
        }
      }

      const TRM = trmNew ? trmNew : trm ? trm : ''
      const amountTrmUsd = parseFloat(getDigitsRegister(amount_new)) / parseFloat(trm)
      const cobruMaxUSD = parseInt(parseInt(cobru?.max) / parseInt(TRM))
      const cobruMinUSD = parseInt(parseInt(cobru?.min) / parseInt(TRM))
      console.log(cobruMaxUSD, cobruMinUSD);
      console.log(parseFloat(getDigitsRegister(amount_new)) < cobruMinUSD);
      console.log(parseFloat(getDigitsRegister(amount_new)) > cobruMaxUSD);

      if (parseFloat(getDigitsRegister(amount_new)) < cobruMinUSD) {
        if (USDPayments()) {
          return true
        }
        let message = translate('min_amount')

        //let message = !!params && params?.int=== 'true'? 'The minimum amount is ': 'El monto mínimo es '

        setErrorMessages({ ...errorMessages, amount: message + formatUSD(cobruMinUSD.toString(), true) + ' USD' })
        return false
      }
      if (parseFloat(getDigitsRegister(amount_new)) > cobruMaxUSD) {
        if (USDPayments()) {
          return true
        }

        let message = translate('max_amount')
        //let message = !!params && params?.int=== 'true'? 'The maximum amount is ': 'El monto máximo es '
        setErrorMessages({ ...errorMessages, amount: message + formatUSD(cobruMaxUSD.toString(), true) + ' USD' })
        return false
      }
      if (parseFloat(getDigitsRegister(amount_new)) <= cobruMaxUSD && getDigitsRegister(amount) >= cobruMinUSD) {
        setErrorMessages({ ...errorMessages, amount: '' })
        return true
      }
      return
      /* console.log('OK', (getDigitsRegister(amount) * trm),cobru?.min);
      if ((getDigitsRegister(amount) * trm) < cobru?.min) {
          setErrorMessages({ ...errorMessages, amount: 'El monto minimo es de ' + formatCOPNumber(cobru?.min) })
          return false
      }
      if ((getDigitsRegister(amount) * trm) > cobru?.max) {

          setErrorMessages({ ...errorMessages, amount: 'El monto maximo es de ' + formatCOPNumber(cobru?.max) })
          return false
      }
      if ((getDigitsRegister(amount) * trm) <= cobru?.max && getDigitsRegister(amount) >= cobru?.min) {
          setErrorMessages({ ...errorMessages, amount: '' })
          return true
      }
      return */
    }
  }

  const validateMaxMinCop = (amount_ = '') => {
    let amount_new = amount_ ? amount_ : amount_ ? amount : ''
    console.log('amount_new: ', amount_new);
    if (getDigitsRegister(amount_new) < cobru?.min) {
      if (USDPayments()) {
        return true
      }
      let message = translate('min_amount')

      setErrorMessages({ ...errorMessages, amount: message + formatCOPNumber(cobru?.min) + ' COP' })
      return false
    }
    if (getDigitsRegister(amount_new) > cobru?.max) {
      if (USDPayments()) {
        return true
      }
      let message = translate('max_amount')

      setErrorMessages({ ...errorMessages, amount: message + formatCOPNumber(cobru?.max) + ' COP' })
      return false
    }
    if (getDigitsRegister(amount_new) <= cobru?.max && getDigitsRegister(amount) >= cobru?.min) {

      setErrorMessages({ ...errorMessages, amount: '' })
      return true
    }
  }


  const getTRM = async () => {
    try {
      const res = await axios.post('/getSwapMoney', { amount: '10000' });
      if (res?.data?.data && res?.status === 200) {
        setTrm(res?.data?.data?.price)
      }
      //console.log('getSwapMoney: ',res);
    } catch (error) {
      console.log(error);
    }
  }
  const fillFields = async () => {
    /* if (params?.int === 'true') {
        setLanguage('en')

    } */
    if (!!params && params?.language) {
      setLanguage(params?.language === 'en' ? 'en' : 'es');
    }
    console.log('fillFields: ', params);
    //console.log(params?.currency.toString().toLowerCase() === 'usd');
    let item_ = null
    if (params?.doc_type) {
      item_ = documentTypes.find(e => e.value.toString() === params?.doc_type.toString())
      console.log('item_: ', item_);
      setDocumentItem(item_)
    }

    if (isTengoPayment) {
      setGlobalCurrency('USD');
    } else if (params?.currency) {
      console.log('currency', params?.currency.toString().toLowerCase() === 'usd' ? 'USD' : 'COP');
      setGlobalCurrency(params?.currency.toString().toLowerCase() === 'usd' ? 'USD' : 'COP')
    }
    if (params?.title) {
      setDescription(params?.title)
    }
    if (params?.amount) {


      if (isTengoPayment) {
        formatUSD(params.amount);
      } else if ((params?.int && !params?.currency)) {
        console.log('entro aca amount');

        let trmNew = null
        if (!trm) {
          const res = await axios.post('/getSwapMoney', { amount: '10000' });
          if (res?.data?.data && res?.status === 200) {
            trmNew = res?.data?.data?.price
          }
        }

        const TRM = trmNew ? trmNew : trm ? trm : ''
        setAmount(formatCOPNumberInput(params?.amount * TRM));

      } else if (globalCurrency === 'COP' || (params?.currency.toString().toLowerCase() === 'cop') || !params?.int || !params?.currency) {

        setAmount(formatCOPNumberInput(params?.amount));
      } else {
        console.log('entro aca amount', selectedMethod);

        formatUSD(params?.amount)

      }

      validateMaxMinUSD(params?.amount)

    }
    if (params?.int === 'true' && !isTengoPayment) {
      console.log('okkkk');
      setIsInt(true)
      //setLanguage('en')
      setGlobalCurrency('USD')
      if (!!params && params?.int === 'true') {

        let amountText = ''
        let amount_ = params?.amount ? params?.amount : amount ? getDigitsRegister(amount) : ''
        if (globalCurrency === 'COP') {
          amountText = (formatCOPNumberInput(amount_));

        } else {
          amountText = formatUSD(amount_, true)
          console.log('amountText: ', amountText);

        }
        setTimeout(() => {
          console.log({ credit_card: true, index: 7, available: true }, amountText + ' USD');
          onChangeBTNName({ credit_card: true, index: 7, available: true }, amountText + ' USD')
        }, 500);
      }
      if (params?.amount) {

        formatUSD(params?.amount || '')
      }

    }
    //old
    // if (params?.int === 'true') {
    //   console.log('okkkk');
    //   setIsInt(true)
    //   //setLanguage('en')
    //   setGlobalCurrency('USD')
    //   if (!!params && params?.int === 'true') {

    //     let amountText = ''
    //     let amount_ = params?.amount ? params?.amount : amount ? getDigitsRegister(amount) : ''
    //     if (globalCurrency === 'COP') {
    //       amountText = (formatCOPNumberInput(amount_));

    //     } else {
    //       amountText = formatUSD(amount_, true)
    //       console.log('amountText: ', amountText);

    //     }
    //     setTimeout(() => {
    //       console.log({ credit_card: true, index: 7, available: true }, amountText + ' USD');
    //       onChangeBTNName({ credit_card: true, index: 7, available: true }, amountText + ' USD')
    //     }, 500);
    //   }
    //   if (params?.amount) {

    //     formatUSD(params?.amount || '')
    //   }

    // }
    /* 
            Object.keys(params).forEach(element => {
                if (element === 'int') {
                    setIsInt(true)
                    return
                }
            }); */
    let name = params?.name || ''
    let palabras = params?.name?.split(' ');
    if (!isBitppi72342403Layout && !!params && params?.int === 'true') {
      if (palabras && palabras.length < 2) {
        name = `${params?.name} ${params?.name}`
      }
    }
    setFormValues(isBitppi72342403Layout
      ? getBitppiProfileFormValues()
      : {
        email: params?.email,
        name: name,
        phone: params?.phone ? formatPhoneNumber(params?.phone) : '',
        doc: params?.doc_number ? formatDocument(params?.doc_number) : '',
        docType: item_?.value || ''
      })
    if (item_?.id) {
      let item = documentTypes.find(e => e.value === item_?.id)
      setDocumentItem(item)
    }
  }

  const getBankList = async () => {
    try {
      const res = await axios.post('/api/getBankList')
      if (res.data.status === 200) {
        let banks = res.data.data
        banks = banks.map(bank => {
          let name = capitalizeSentence(bank.bankName)
          return ({ label: name, value: bank.bankCode })
        })
        banks = [{ value: '', label: translate('select_bank_label') }, ...banks]
        //console.log('Bancos', banks);
        setBankList(banks)
      }
    } catch (error) {
      setErrorMessage(translate('error_getting_bank_list'))

    }
  }

  const getCobruInfo = async () => {
    try {
      const res = await axios.post('/api/getCobruDetails', { cobruURL: cobruURL })
      console.log('res getCobruInfo', res);

      if (res.data && res?.status === 200) {
        setPaymentsMethod(res.data.data.payment_methods_configuration)
        setShowCobru(true)
      } else if (res?.data === '' && res?.status === 200) {
        setShowCobru(false)
      } else {
        setShowCobru(false)

      }
    } catch (error) {
      console.log('res error: ', error);
      setShowCobru(false)
    }
  }
  const resetAllTimers = (options = {}) => {
    const { keepUsdtNetworkDebounce = false } = options;
    setRunTimerCheck(false);
    setRunTimerCheckDaviplata(false);
    setRunTimerCheckBreb(false);

    runTimerCheckRef.current = false;
    runTimerBrebRef.current = false;

    if (cryptoIntervalRef.current) {
      clearInterval(cryptoIntervalRef.current);
      cryptoIntervalRef.current = null;
    }

    if (cryptoInterval) {
      clearInterval(cryptoInterval);
    }

    if (daviplataInterval) {
      clearInterval(daviplataInterval);
    }

    if (intervalBREB) {
      clearInterval(intervalBREB);
    }

    setCryptoInterval(null);
    setDaviplataInterval(null);
    setIntervalBREB(null);

    setCountDown('');
    setCountDownDaviplata('');
    setPaymentDetails({});
    paymentDetailsRef.current = null;
    brebStatusRef.current = null;

    // Reset rate limit countdown
    if (rateLimitIntervalRef.current) {
      clearInterval(rateLimitIntervalRef.current);
      rateLimitIntervalRef.current = null;
    }
    setRateLimitSeconds(0);

    // Cancela debounce pendiente (excepto si estamos re-programando con keepUsdtNetworkDebounce)
    if (!keepUsdtNetworkDebounce && usdtNetworkSwitchTimeoutRef.current) {
      clearTimeout(usdtNetworkSwitchTimeoutRef.current);
      usdtNetworkSwitchTimeoutRef.current = null;
    }
  };

  const extractSecondsFromRateLimitMessage = (msg) => {
    if (!msg) return null;
    // Ej: "Vuelva a intentarlo en unos 30.0 segundos."
    const match = String(msg).match(/(\d+(?:\.\d+)?)\s*segundos?/i);
    if (!match) return null;
    const n = Math.ceil(parseFloat(match[1]));
    return Number.isFinite(n) ? n : null;
  };

  const startRateLimitCountdown = (msgOrSeconds) => {
    const seconds =
      typeof msgOrSeconds === 'number'
        ? Math.max(0, Math.ceil(msgOrSeconds))
        : (extractSecondsFromRateLimitMessage(msgOrSeconds) || 30);

    if (rateLimitIntervalRef.current) {
      clearInterval(rateLimitIntervalRef.current);
      rateLimitIntervalRef.current = null;
    }

    // Bloquea nuevos intentos hasta que expire el rate limit (también para tabs cripto)
    nextCryptoGetDetailsAllowedAtRef.current = Date.now() + (seconds * 1000);

    setRateLimitSeconds(seconds);
    rateLimitIntervalRef.current = setInterval(() => {
      setRateLimitSeconds((prev) => {
        const next = Math.max(0, (prev || 0) - 1);
        if (next <= 0 && rateLimitIntervalRef.current) {
          clearInterval(rateLimitIntervalRef.current);
          rateLimitIntervalRef.current = null;
        }
        return next;
      });
    }, 1000);
  };


  // Normaliza respuestas de getDetailsPay que vienen "anidadas"
  // Ej 1 (directo): { result, error }
  // Ej 2 (envuelto): { data: { result, error }, status: 400, statusText: "Bad Request" }
  const unwrapGetDetailsPayError = (obj) => {
    if (!obj || typeof obj !== 'object') return null;
    if (obj?.result || obj?.error || obj?.cause || obj?.message) return obj;
    if (obj?.data && typeof obj.data === 'object') return unwrapGetDetailsPayError(obj.data);
    return null;
  };

  const resetData = () => {
    resetAllTimers();

    setErrorMessage('')
    setRunTimerCheckDaviplata(false)
    setRunTimerCheckBreb(false)
    setRunTimerCheck(false)
    runTimerCheckRef.current = false;

    // Reset Bre-B modal/timer state
    setShowCanceledModal(false)
    runTimerBrebRef.current = false
    brebStatusRef.current = null
    paymentDetailsRef.current = null
    if (intervalBREB) clearInterval(intervalBREB)
    if (daviplataInterval) clearInterval(daviplataInterval)
    if (cryptoIntervalRef.current) {
      clearInterval(cryptoIntervalRef.current);
      cryptoIntervalRef.current = null;
    }
    setCryptoInterval(null)
    setIntervalBREB(null)
    setDaviplataInterval(null)

    setErrorMessages({
      amount: '',
      name: '',
      docType: '',
      doc: '',
      email: '',
      phone: '',
    })
    setLoading(false)
    setOTPNumber('')
    setShowOTP(false)
    setCountDownDaviplata('')
    setDaviplataInfo(null)
    setSuccessCheck(false)
    //setIsInt(false)
  }

  const addParms = async (value = '') => {
    window.history.replaceState(null, null, `?url=${value}`);
  }

  /* const fillUrl = async () => {
      // Obtén la URL actual
      let baseUrl = '';
      let currentUrl = window.location.href;
      let params_ = new URLSearchParams(params);
      console.log('cobruURL', params_.toString());
      let newCobruUrl = cobruURL ? `/${cobruURL}` : ""
      
      let finalUrl = baseUrl +params_.toString() ? newCobruUrl + '?' + params_.toString() : newCobruUrl + '' + params_.toString();
      // Reemplaza "home" con tus nuevos parámetros
      //console.log(finalUrl);
      let newUrl = currentUrl.replace("/home", finalUrl);
      // Reemplaza el estado actual en el historial
      window.history.replaceState(null, null, newUrl);
  } */
  const fillUrl = async () => {
    try {
      let currentUrl = window.location.href;
      let baseUrl = window.location.origin; // Obtener base URL (e.g., https://example.com)
      let params_ = new URLSearchParams(params);

      console.log('cobruURL', params_.toString());

      let newCobruUrl = cobruURL ? `/${cobruURL}` : "";
      let queryString = params_.toString() ? `?${params_.toString()}` : "";

      // Construcción correcta de la URL final
      let finalUrl = `${baseUrl}${newCobruUrl}${queryString}`;

      // Solo actualizar la URL si ha cambiado
      if (currentUrl !== finalUrl) {
        window.history.replaceState(null, null, finalUrl);
      }
    } catch (error) {
      console.error("Error en fillUrl:", error);
    }
  };
  const formatAmount = (value) => {
    if (!value) return 0;
    return parseFloat(parseFloat(value).toFixed(2));
  };

  const refreshCryptoDetails = async (payment, requestId = null) => {
    try {
      const baseCobruUrl = shouldCreateCobru
        ? createdCobruURLRef.current
        : (cobruURL_ || cobruURL);
      if (!baseCobruUrl) {
        setLoading(false);
        return;
      }
      if (!formValues?.name || !formValues?.email || !formValues?.phone) {
        setLoading(false);
        return;
      }

      setLoading(true);

      const brandName = getActiveVariableBrand(baseCobruUrl);
      const cobruURLToUse =
        (brandName === 'COLOCA' || brandName === 'TENGO')
          ? `${(cobru?.brand || brandName || '')}-${baseCobruUrl}`
          : (brandName === 'ezytransfer' || brandName === 'ezy_transfer')
            ? `${(cobru?.brand || brandName || '')}-${baseCobruUrl}`
            : brandName === 'BITPPI'
              ? `${(cobru?.brand || brandName || '')}-${baseCobruUrl}`
              : baseCobruUrl;
      const cobruURLToUseApi = stripBrandPrefixFromCobruURL(cobruURLToUse);

      const payload = {
        name: formValues.name,
        payment,
        cc: formValues.doc
          ? getDigitsRegister(formValues.doc)
          : documentItem.value
            ? getDigitsRegister(documentItem.value)
            : '',
        email: formValues.email,
        phone: formValues.phone.replace(/\D/g, ""),
        document_type: documentItem?.value === 8 ? 4 : documentItem?.value,
        payer_country_code: country ? `+${country?.indicative}` : '',
        platform: 'WEB',
        note: getPaymentDeviceNote(),
        latitude: payerLocationRef.current?.latitude ?? null,
        longitude: payerLocationRef.current?.longitude ?? null
      };

      const resp = await axios.post('/api/getDetailsPay', {
        cobruURL: cobruURLToUseApi,
        payload
      });
      console.log('resrawDetailsPay: ', resp);

      // Manejo robusto de errores (a veces el backend devuelve un objeto, no un JSON string)
      const rawDetailsPay = resp?.data?.data;
      const detailsPayObj =
        typeof rawDetailsPay === 'string'
          ? (() => {
            try { return JSON.parse(rawDetailsPay); } catch { return null; }
          })()
          : rawDetailsPay;

      const normalizedDetailsPayErr = unwrapGetDetailsPayError(detailsPayObj);
      if (normalizedDetailsPayErr && (normalizedDetailsPayErr?.error || (normalizedDetailsPayErr?.result && normalizedDetailsPayErr?.result !== 'OK'))) {
        if (normalizedDetailsPayErr?.result === 'COBRU_OUT_RATE_LIMIT_TRX') {
          // No mostrar el mensaje de rate limit al usuario en tabs cripto.
          // Mantener "Generando..." y reintentar automáticamente cuando se cumpla el delay.
          startRateLimitCountdown(normalizedDetailsPayErr?.error);
          setErrorMessage('');
          setShowForm(false);
          setShowQr(false);
          setQrValue(null);
          setCurrencyWallet('');
          setLoading(true);

          const now = Date.now();
          const waitMs = Math.max(0, (nextCryptoGetDetailsAllowedAtRef.current || 0) - now);
          if (usdtNetworkSwitchTimeoutRef.current) {
            clearTimeout(usdtNetworkSwitchTimeoutRef.current);
            usdtNetworkSwitchTimeoutRef.current = null;
          }
          usdtNetworkSwitchTimeoutRef.current = setTimeout(() => {
            if (requestId !== null && requestId !== cryptoDetailsRequestIdRef.current) return;
            void refreshCryptoDetails(payment, requestId);
          }, waitMs);
          return;
        }
        setErrorMessage(
          normalizedDetailsPayErr?.error ||
          normalizedDetailsPayErr?.cause ||
          normalizedDetailsPayErr?.message ||
          translate('unexpected_error')
        );
        setLoading(false);
        return;
      }
      console.log('rawDetailsPay: ', rawDetailsPay);

      // Axios normalmente expone el status HTTP en `resp.status`
      // (algunos backends también devuelven `data.status`)
      if (resp?.status === 200 || resp?.data?.status === 200) {
        // Si no es string (ya es objeto/array), úsalo directamente
        const dataRes =
          typeof rawDetailsPay === 'string'
            ? JSON.parse(rawDetailsPay)
            : rawDetailsPay;
        const details = dataRes ? dataRes[0].fields : null;

        if (!details?.qr_bitcoin) {
          setErrorMessage(`No se pudo generar el QR de ${payment}. Inténtalo de nuevo.`);
          setLoading(false);
          return;
        }

        // Si esta respuesta no es de la última solicitud, ignorarla para evitar "parpadeo" de QRs
        if (requestId !== null && requestId !== cryptoDetailsRequestIdRef.current) {
          setLoading(false);
          return;
        }

        setPaymentDetails(details);
        runTimerCheckRef.current = true;
        setRunTimerCheck(true);
        subtractTimeReload(details?.checkout?.toString());

        setShowForm(false);
        setQrValue(details.qr_bitcoin);
        setCurrencyWallet(details.url);
        setShowQr(true);

        // Cooldown: 3s desde que el QR quedó generado en pantalla
        nextCryptoGetDetailsAllowedAtRef.current = Date.now() + CRYPTO_GET_DETAILS_MIN_GAP_MS;
      }

      setLoading(false);
    } catch (error) {
      console.log('error refreshCryptoDetails', error);
      // Si axios recibe status 400, cae aquí (error.response)
      const errData = error?.response?.data?.data;
      const normalizedErr = unwrapGetDetailsPayError(errData);
      if (normalizedErr && typeof normalizedErr === 'object') {
        if (normalizedErr?.result === 'COBRU_OUT_RATE_LIMIT_TRX') {
          // No mostrar el mensaje de rate limit al usuario en tabs cripto.
          // Mantener "Generando..." y reintentar automáticamente cuando se cumpla el delay.
          startRateLimitCountdown(normalizedErr?.error);
          setErrorMessage('');
          setShowForm(false);
          setShowQr(false);
          setQrValue(null);
          setCurrencyWallet('');
          setLoading(true);

          const now = Date.now();
          const waitMs = Math.max(0, (nextCryptoGetDetailsAllowedAtRef.current || 0) - now);
          if (usdtNetworkSwitchTimeoutRef.current) {
            clearTimeout(usdtNetworkSwitchTimeoutRef.current);
            usdtNetworkSwitchTimeoutRef.current = null;
          }
          usdtNetworkSwitchTimeoutRef.current = setTimeout(() => {
            if (requestId !== null && requestId !== cryptoDetailsRequestIdRef.current) return;
            void refreshCryptoDetails(payment, requestId);
          }, waitMs);
          return;
        }
        setErrorMessage(
          normalizedErr?.error ||
          normalizedErr?.cause ||
          normalizedErr?.message ||
          translate('unexpected_error')
        );
      } else {
        setErrorMessage(translate('unexpected_error'));
      }
      setLoading(false);
    }
  };

  // Mismas reglas que validateDataBasic, sin "loading" — útil al cambiar tab cripto (mostrar u ocultar el form)
  const isFormBasicFieldsComplete = () => {
    let invalid = false;
    if (showPhoneCobru && formValues?.phone && amount) {
      return true;
    }
    if (!formValues?.name || !payMethodName || !formValues?.doc || !formValues?.email || !formValues?.phone) {
      invalid = true;
    }
    if (payMethodName === 'pse' && bankPse.value === '') {
      invalid = true;
    }
    if (payMethodName === 'credit_card') {
      if (creditCardNumber.replace(/\D/g, "").length < 13 || creditCardDate.length < 5 || creditCardCVV.length < 3) {
        invalid = true;
      }
    }
    if (isAPhone) {
      if (errorMessages.amount !== '') {
        invalid = true;
      }
      if (params?.amount) {
        invalid = false;
      }
    }
    return !invalid;
  };

  // Cambio de red cripto: mantiene 3s entre generaciones, pero no “dobla” la espera si ya pasó el gap
  const scheduleUsdtNetworkRefresh = (payment) => {
    // En perfiles se debe crear primero el Cobru; cambiar de red no genera una transacción por sí solo.
    if (shouldCreateCobru && !createdCobruURLRef.current) {
      return;
    }

    if (usdtNetworkSwitchTimeoutRef.current) {
      clearTimeout(usdtNetworkSwitchTimeoutRef.current);
      usdtNetworkSwitchTimeoutRef.current = null;
    }

    usdtNetworkSwitchIdRef.current += 1;
    const switchId = usdtNetworkSwitchIdRef.current;

    // Limpia timers/QR de la red anterior, pero mantiene el programador (debounce/cooldown)
    resetAllTimers({ keepUsdtNetworkDebounce: true });
    setErrorMessage('');
    // Form incompleto: dejarlo visible. Si ya está lleno, no mostrarlo mientras se regenera el QR
    setShowForm(!isFormBasicFieldsComplete());
    setShowQr(false);
    setQrValue(null);
    setCurrencyWallet('');
    setLoading(true);

    const now = Date.now();
    const waitMs = Math.max(0, (nextCryptoGetDetailsAllowedAtRef.current || 0) - now);
    // Si aún no han pasado 3s desde el último QR generado, mantenemos loading hasta que se pueda disparar.

    usdtNetworkSwitchTimeoutRef.current = setTimeout(() => {
      // Si hubo otro click de tab, ignorar
      if (switchId !== usdtNetworkSwitchIdRef.current) return;

      cryptoDetailsRequestIdRef.current += 1;
      const reqId = cryptoDetailsRequestIdRef.current;
      void refreshCryptoDetails(payment, reqId);
    }, waitMs);
  };

  const pay = async (push = true) => {
    try {

      resetData()
      //Validaciones:
      if (!showPhoneCobru && !validateInput().all()) {
        console.log('ok');

        return
      }
      const payerLocation = await requestPayerLocation();
      setLoading(true)
      const res = await onSubmitRecaptchaValue()
      console.log('onSubmitRecaptchaValue: ', res);
      if (res) {
        setShowRecaptcha(false)
      } else {
        setLoading(false)
        setShowRecaptcha(true)
        return
      }

      if (isCaptchaValid || res) {
        console.log('isCaptchaValid');

        const brandName = getActiveVariableBrand(cobruURL)
        console.log('brandName getCobruInfoByPhone', brandName);
        let url = null
        let cobruURL_ = (brandName === 'COLOCA' || brandName === 'TENGO') ? `${(cobru?.brand || brandName || '')}-${cobruURL}` : (brandName === 'ezytransfer' || brandName === 'ezy_transfer') ? `${(cobru?.brand || brandName || '')}-${cobruURL}` : brandName === 'BITPPI' ? `${(cobru?.brand || brandName || '')}-${cobruURL}` : cobruURL
        let payload_ = {
          amount: isTengoPayment
            ? formatAmount(parseTengoUsdAmount(amount || params?.amount) * quantity)
            : formatAmount(
                        /* payMethodName === 'safeay' ?
                        getDigits(amount) * quantity
                        :
                        cobru?.amount && cobru?.currency_code === 'USD' && !USDPayments()?
                        (((getDigitsRegister(amount) * quantity) * trm)):
                        globalCurrency === 'USD' 
                        ? (((getDigitsRegister(amount) * quantity) * trm)) 
                        : */ getDigits(amount) * quantity),
          phone: cobruURL_,
          description: description || '',
          payer_redirect_url: params?.payer_redirect_url || '',
          note: getPaymentDeviceNote()
        }
        //console.log('payload_', payload_);
        //return
        const isInternational = params?.int === true || params?.int === 'true';

        if (isTengoPayment || payMethodName === 'safetypay' || (payMethodName === 'USDT' && isInternational)) {
          payload_.currency_code = 'USD'
        }
        //creacion del cobru 
        console.log('payload_', payload_);
        console.log('payMethodName', payMethodName);

        if (shouldCreateCobru /* && !url */) {
          const res = await axios.post('/cobru', payload_/* {
                        amount: formatAmount(globalCurrency === 'USD' 
                            ? (((getDigitsRegister(amount) * quantity) * trm)) 
                            : getDigits(amount) * quantity),
                        phone: cobruURL,
                        description: description || '',
                        payer_redirect_url: params?.payer_redirect_url || ''
                    } */)
          console.log('res cobru: ', res);
          if (res?.status === 200 && res?.data?.data?.result === 'OK') {
            const createdCobruURL = res?.data?.data?.url;
            createdCobruURLRef.current = createdCobruURL;
            setCobruURL_(createdCobruURL)
            url = createdCobruURL
            setCobruItemBack(res?.data?.data)
            //lksdsd
            addParms(url)
          } else {
            setLoading(false)
            setErrorMessage(translate('cobru_created_error'))
            return
          }

        }


        const effectivePayment =
          payMethodName === 'USDT'
            ? (cryptoNetwork || 'USDT')
            : payMethodName;

        let payload = {
          "name": formValues.name,
          "payment": effectivePayment,
          "cc": formValues.doc ? getDigitsRegister(formValues.doc) : documentItem.value ? getDigitsRegister(documentItem.value) : '',
          "email": formValues.email,
          "phone": formValues.phone.replace(/\D/g, ""),
          "document_type": documentItem?.value === 8 ? 4 : documentItem?.value,
          payer_country_code: country ? `+${country?.indicative}` : '',
          platform: 'WEB',
          note: getPaymentDeviceNote(),
          latitude: payerLocation?.latitude ?? null,
          longitude: payerLocation?.longitude ?? null
        }


        console.log('payload:', payload);
        console.log('formValues:', formValues);


        /* const payMethodName = Object.keys(currentPaymentMethod.name)[0] */
        if (!!params && params?.callback_url) {
          payload.callback = params?.callback_url

        }
        if (isEzy) {
          payload.payer_redirect_url = 'https://www.ezytransfer.co/'

        }
        if (!!params && params?.redirect_url) {

          payload.payer_redirect_url = params?.redirect_url

        }
        if (payMethodName === 'NEQUI') {
          /* payload.phone_nequi = formValues.phone.replace(/\D/g, "")
          payload.push = push */
          payload.payer_redirect_url = params?.redirect_url

        }
        if (payMethodName === 'pse') {
          payload.bank = bankPse.value
          if (!!params && params?.redirect_url) {
            payload.payer_redirect_url = params?.redirect_url
          }
        }

        if (payMethodName == 'BTC') {

        }
        // Bre-B: backend retorna qr_value y key_value en la respuesta (no se envía check_qr)
        /* if (payMethodName === "daviplata") {
            payload.cc = '996828'
        } */
        if (payMethodName === 'credit_card') {
          payload.dues = parseInt(creditCardCuotas.value);

          if (!isGateway24) {
            payload.credit_card = creditCardNumber.replace(/\D/g, "");
            payload.expiration_date = creditCardDate;
            payload.cvv = creditCardCVV;
          }
        }

        if (payMethodName === 'cobru') {
          payload.payment = 'cobru_phone'
          let currentUrl = window.location.href;
          const parsedUrl = new URL(currentUrl);
          //console.log('parsedUrl: ',parsedUrl);
          payload.phone = formValues?.phone
          payload.email = cobru?.owner_email
          payload.cc = cobru?.owner_document
          payload.document_type = documentItem?.label2 || 'CC'
          payload.name = cobru?.name
        }
        console.log('url', url)
        console.log('cobruURL_', cobruURL_)
        console.log('payload: ', payload);
        //const resp = await axios.post('/api/getDetailsPay', { cobruURL: (isPhoneNumber && !params?.amount) ? url : (isPhoneNumber && params?.amount )? url :cobruURL_, payload })
        const resp = await axios.post('/api/getDetailsPay', {
          cobruURL: stripBrandPrefixFromCobruURL(shouldCreateCobru ? url : cobruURL_),
          payload
        });
        console.log('resp: ', resp);

        console.log('Respuesta directa', resp?.data?.data?.cause);
        // Manejo robusto de errores (ej: { result: "COBRU_OUT_RATE_LIMIT_TRX", error: "..." })
        const rawPayDetails = resp?.data?.data;
        const payDetailsObj =
          typeof rawPayDetails === 'string'
            ? (() => {
              try { return JSON.parse(rawPayDetails); } catch { return null; }
            })()
            : rawPayDetails;

        const normalizedPayErr = unwrapGetDetailsPayError(payDetailsObj);
        if (normalizedPayErr && (normalizedPayErr?.error || (normalizedPayErr?.result && normalizedPayErr?.result !== 'OK'))) {
          if (normalizedPayErr?.result === 'COBRU_OUT_RATE_LIMIT_TRX') {
            startRateLimitCountdown(normalizedPayErr?.error);
          }
          setErrorMessage(
            normalizedPayErr?.error ||
            normalizedPayErr?.cause ||
            normalizedPayErr?.message ||
            translate('unexpected_error')
          );
          setLoading(false);
          return;
        }

        // Compatibilidad con estructura vieja { error: true, cause: "..." }
        if (resp?.data?.data?.error) {
          setErrorMessage(resp?.data?.data?.cause || translate('unexpected_error'))
          setLoading(false)
          return
        }
        if (resp.data.status === 200) {
          if (payMethodName === 'cobru') {
            setLoading(false)
            setSuccessCheck(true)
            return

          }
          let str = JSON.stringify(resp?.data?.data)
          console.log(resp.data.data);
          let dataRes =
            typeof rawPayDetails === 'string'
              ? JSON.parse(rawPayDetails)
              : rawPayDetails
          const paymentDetails = dataRes ? dataRes[0].fields : false
          const paymentDetailsCobru = dataRes ? dataRes[1].fields : false
          JSON.parse(str)

          console.log('data transformado:', dataRes);
          console.log('paymentDetails:', paymentDetails);
          //console.log('str', );
          if (payMethodName === 'NEQUI') {
            window.location.href = `${dataRes[0]?.fields?.checkout}`;
            setLoading(false)

            /* if (push) {
                setShowForm(false)
                setWaitingNequiPay(true)
                setLoading(false)

            } else {
                setWaitingNequiPay(false)

                console.log(dataRes);
                setShowForm(false)
                setQrValue(dataRes[0].fields.ref)
                setShowQr(true)
                setLoading(false)

            } */
          }

          if (payMethodName === 'dale') {
            console.log(dataRes);
            window.location.href = `${dataRes[0]?.fields?.checkout}`;
          }
          if (payMethodName === 'corresponsal_bancolombia') {
            setPayPin({ code: dataRes[0]?.fields?.project_code, ref: dataRes[0]?.fields?.ref })
            setShowForm(false)
            setShowPin(true)
            setLoading(false)

            console.log(dataRes);
          }
          if (payMethodName === 'efecty') {
            const date = dataRes[1]?.fields?.expiration_date;

            const fecha = new Date(date);

            const newDateFormat = fecha.toISOString().replace(/-/g, "/").slice(0, 10);

            setPayPin({ code: dataRes[0]?.fields?.project_code, ref: dataRes[0]?.fields?.ref })
            setShowForm(false)
            setShowPin(true)
            setExpDate(newDateFormat)
            setLoading(false)

            console.log(dataRes);
          }
          if (payMethodName === 'pse') {
            //console.log('llega aca');
            console.log(dataRes);
            window.location.href = `${dataRes[0]?.fields?.checkout}`;
            setLoading(false)

          }
          if (payMethodName === 'safetypay') {
            //console.log('llega aca');
            console.log(dataRes);
            window.location.href = `${dataRes[0]?.fields?.checkout}`;
            setLoading(false)

          }
          if (payMethodName === 'bancolombia_transfer') {
            //console.log('llega aca');
            console.log(dataRes);
            window.location.href = `${dataRes[0]?.fields?.checkout}`;
            setLoading(false)

          }
          if (payMethodName === 'tpaga') {
            //console.log('llega aca');
            console.log(dataRes);
            window.location.href = `${dataRes[0]?.fields?.checkout}`;
            setLoading(false)

          }
          if (payMethodName === 'BTC') {
            setLoading(false)

          }
          if (effectivePayment === 'USDT' || effectivePayment === 'ETH' || effectivePayment === 'POLYGON') {
            console.log(`${effectivePayment} paymentDetails:`, paymentDetails);

            if (!paymentDetails || !paymentDetails.qr_bitcoin) {
              console.error("No se encontró un QR válido en la respuesta.");
              setErrorMessage(`No se pudo generar el QR de ${effectivePayment}. Inténtalo de nuevo.`);
              setLoading(false);
              return;
            }

            setPaymentDetails(paymentDetails);
            runTimerCheckRef.current = true;
            setRunTimerCheck(true);
            subtractTimeReload(paymentDetails?.checkout?.toString());

            setTimeout(() => {
              setShowForm(false);
              setQrValue(paymentDetails.qr_bitcoin);
              setCurrencyWallet(paymentDetails.url);
              setShowQr(true);
              console.log(`QR ${effectivePayment} mostrado correctamente.`);
            }, 100);

            setLoading(false);
          }
          if (payMethodName === 'breb') {
            console.log("breb paymentDetails:", paymentDetails);

            const hasQR = !!paymentDetails?.qr_value;
            const hasKey = !!paymentDetails?.key_value;

            if (!paymentDetails || (!hasQR && !hasKey)) {
              console.error("No se encontró QR ni llave válida en la respuesta.");
              setErrorMessage("No se pudo generar la información de Bre-B. Inténtalo de nuevo.");
              setLoading(false);
              return;
            }

            setPaymentDetails(paymentDetails);
            paymentDetailsRef.current = paymentDetails;

            setRunTimerCheckBreb(true);
            runTimerBrebRef.current = true;

            setCountDown("05:00");
            subtractTimeReloadBreb(300);

            setTimeout(() => {

              setShowForm(false);

              setQrValue(paymentDetails?.qr_value || null);
              setCurrencyWallet(paymentDetails?.key_value || null);

              // Mostrar QR si existe
              setShowQr(hasQR);

              console.log("Bre-B listo:");
              console.log("QR:", paymentDetails?.qr_value);
              console.log("KEY:", paymentDetails?.key_value);

            }, 100);

            setLoading(false);
          }

          /* if (payMethodName === 'USDT') {
              setPaymentDetails(paymentDetails)
              setRunTimerCheck(true)
              subtractTimeReload(paymentDetails?.checkout.toString())
              setShowForm(false)
              setQrValue(paymentDetails.qr_bitcoin)
              setCurrencyWallet(paymentDetails.url)
              setShowQr(true)
              setLoading(false)

          } */
          // if (payMethodName === "credit_card") {

          //   setPaymentDetails(paymentDetails)
          //   setPaymentDetailsCobru(paymentDetailsCobru)
          //   setShowForm(false)
          //   setSuccessCheck(true)
          //   setLoading(false)
          //   const hostname = window?.location?.hostname;
          //   if (hostname === 'link-dev.cobru.co' || hostname === 'dev.cobru.co') {
          //     process3DS(paymentDetails?.['3ds'])
          //     return
          //   }

          // }
          if (payMethodName === "credit_card") {
            if (isGateway24) {
              const checkout =
                paymentDetails?.checkout ||
                paymentDetailsCobru?.checkout ||
                dataRes?.[0]?.fields?.checkout ||
                dataRes?.[1]?.fields?.checkout;

              if (checkout) {
                window.location.href = checkout;
                return;
              }

              setErrorMessage('No se recibió checkout');
              setLoading(false);
              return;
            }

            // flujo viejo
            setPaymentDetails(paymentDetails);
            setPaymentDetailsCobru(paymentDetailsCobru);
            setShowForm(false);
            setSuccessCheck(true);
            setLoading(false);
          }
          if (payMethodName === "daviplata") {
            //setShowForm(false)
            setPaymentDetails(paymentDetails)
            setPaymentDetailsCobru(paymentDetailsCobru)
            setRunTimerCheckDaviplata(true)
            subtractTimeDaviplata(120)
            setShowOTP(true)
            setLoading(false)

          }
          setLoading(false)

        }

        if (resp.data.data.error) {
          if (resp.data.data.error === "Payment method is not enabled.") setErrorMessage(translate('payment_method_not_enbled_error'))
          else setErrorMessage(resp.data.data.error)


        } else if (resp?.data?.status === 400) {


          setErrorMessage(translate('unexpected_error'))
          setLoading(false)

        }
        console.log('que devuelve getDetailsPay', resp);
        /*         setQrValue(resp)
        setShowForm(false)
        setShowQr(true) */
        setLoading(false)

      }
    } catch (error) {
      console.log('error pay', error?.response?.data?.data?.message);
      console.log('error pay catch', error);
      const errData = error?.response?.data?.data;
      if (errData && typeof errData === 'object') {
        if (errData?.result === 'COBRU_OUT_RATE_LIMIT_TRX') {
          startRateLimitCountdown(errData?.error);
        }
        if (errData?.error || errData?.cause || errData?.message) {
          setErrorMessage(errData?.error || errData?.cause || errData?.message);
          setLoading(false);
          return;
        }
      }
      if (error?.response?.data?.data?.message) {
        setErrorMessage((error?.response?.data?.data?.message))
        setLoading(false)
        return
      }
      setErrorMessage(translate('unexpected_error'))
      setLoading(false)

    }
  }

  const handleInputChange = (event) => {
    const { value } = event.target;
    const formatValue = formatCOPNumber(value);
    setAmount(formatValue);
  }

  const subtractTimeReload = async (time) => {
    // Evitar timers cruzados: si ya había un intervalo corriendo, lo detenemos antes de iniciar uno nuevo
    if (cryptoIntervalRef.current) {
      clearInterval(cryptoIntervalRef.current);
      cryptoIntervalRef.current = null;
    }
    if (cryptoInterval) {
      clearInterval(cryptoInterval);
    }

    let count = parseFloat(time) * 1000;

    // Pintar el contador inmediatamente (sin esperar 1s al primer tick)
    const initial = await millisecondsToMinutesAndSeconds(count);
    if (initial?.minutes !== undefined && initial?.seconds !== undefined) {
      setCountDown(initial.minutes + ":" + (initial.seconds < 10 ? '0' : '') + initial.seconds);
    }

    const newTimer = setInterval(async () => {
      if (!runTimerCheckRef.current) {
        clearInterval(newTimer);
        cryptoIntervalRef.current = null;
        return;
      }

      count -= 1000;

      const newMin = await millisecondsToMinutesAndSeconds(count);
      const { minutes, seconds } = newMin;

      setCountDown(minutes + ":" + (seconds < 10 ? '0' : '') + seconds);

      if (count <= 0) {
        clearInterval(newTimer);
        cryptoIntervalRef.current = null;
        setPaymentDetails({});
        setCountDown('');
        runTimerCheckRef.current = false;
        setRunTimerCheck(false);
        setShowQr(false);
        setShowForm(true);
        return;
      }

      if ((parseInt(seconds) % 5) === 0) {
        setPaymentDetails(prevState => {
          getCryptoStatusReload(prevState);
          return prevState;
        });
      }
    }, 1000);

    cryptoIntervalRef.current = newTimer;
    setCryptoInterval(newTimer);
  };
  // const subtractTimeReload = async (time) => {
  //   console.log('time: ', time);
  //   let count = (parseInt(time) * 1000);

  //   //let count = 1200000;
  //   const newTimer = setInterval(async () => {
  //     count -= 1000;
  //     const newMin = await millisecondsToMinutesAndSeconds(count)
  //     const { minutes, seconds } = newMin
  //     /* console.log('seconds', parseInt(seconds));
  //     console.log('minutes', parseInt(minutes));
  //     console.log(count); */
  //     console.log('seconds', parseInt(seconds));
  //     console.log('minutes', parseInt(minutes))
  //     setCountDown(minutes + ":" + (seconds < 10 ? '0' : '') + seconds);
  //     console.log('runTimerCheck', runTimerCheck);
  //     if (count <= 0 || parseInt(minutes) <= 0 || runTimerCheck === false) {
  //       console.log('clearInterval:');
  //       clearInterval(newTimer);
  //       setPaymentDetails({})
  //       setCountDown('')
  //       setRunTimerCheck(false)
  //       setShowQr(false)

  //       setShowForm(true)
  //       //getOpt('SMS');
  //     } else if ((parseInt(seconds) % 5) === 0) {
  //       //console.log('5 segussss');
  //       setPaymentDetails(prevState => {
  //         getCryptoStatusReload(prevState)
  //         return prevState
  //       })
  //     }

  //   }, 1000);
  //   setCryptoInterval(newTimer);
  // };
  const subtractTimeReloadBreb = async (time) => {
    console.log("⏱️ Timer Breb iniciado con:", time);

    let count = parseInt(time) * 1000; // ms

    const newTimer = setInterval(async () => {
      // If timer is disabled from outside, stop cleanly
      if (!runTimerBrebRef.current) {
        clearInterval(newTimer);
        return;
      }

      count -= 1000;

      const { minutes, seconds } = await millisecondsToMinutesAndSeconds(count);
      const formatted = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;

      setCountDown(formatted);

      // ---- WHEN TIME REACHES 0 ----
      if (count <= 0) {
        clearInterval(newTimer);
        runTimerBrebRef.current = false;

        setRunTimerCheckBreb(false);
        setCountDown("00:00");

        // Show modal ONLY if NOT completed
        if (brebStatusRef.current !== "COMPLETED") {
          setShowCanceledModal(true);
        }
        return;
      }

      // ---- POLLING EVERY 5s ----
      if (parseInt(seconds) % 5 === 0) {
        getStatusBreb(paymentDetailsRef.current);
      }
    }, 1000);

    setIntervalBREB(newTimer);
  };
  const subtractTimeDaviplata = async (time) => {
    console.log('time: ', time);
    let count = (parseInt(time) * 1000);

    //let count = 1200000;
    const newTimer = setInterval(async () => {
      count -= 1000;
      const newMin = await millisecondsToMinutesAndSeconds(count)
      const { minutes, seconds } = newMin
      /* console.log('seconds', parseInt(seconds));
      console.log('minutes', parseInt(minutes));
      console.log(count); */
      console.log('seconds', parseInt(seconds));
      console.log('minutes', parseInt(minutes))
      setCountDownDaviplata(minutes + ":" + (seconds < 10 ? '0' : '') + seconds);
      console.log('runTimerCheck', runTimerCheckDaviplata);
      if (count <= 0 || parseInt(minutes) <= 0 || runTimerCheckDaviplata === false) {
        console.log('clearInterval:');
        setRunTimerCheckDaviplata(false)
        setCountDownDaviplata('')
        clearInterval(newTimer)
        //getOpt('SMS');
      } /* else if ((parseInt(seconds) % 5) === 0) {
                console.log('5 segundos');
                setRunTimerCheckDaviplata(false)
                setCountDownDaviplata('')


                
            } */

    }, 1000);
    setDaviplataInterval(newTimer);
  };

  /*   useEffect(() => {
        console.log('showQr', showQr);
        console.log('qrValue', qrValue);
    }, [showQr, qrValue]) */

  const getCryptoStatusReload = async (paymentDetails) => {
    /* let status = await API.GET.GetCryptoTransactionStatus(paymentDetails.GOrdenId, paymentDetails.method); */
    try {
      let status = await axios.post('/crypto_status', { transactionID: paymentDetails.GOrdenId, method: paymentDetails.method });
      status = status?.data?.data
      console.log('status: ', status, paymentDetails);
      // if (status?.state == "approved") {
      //   console.log('Pago aprobado, cerrando QR.');
      //   runTimerCheckRef.current = false;
      //   setRunTimerCheck(false);
      //   setShowQr(false);
      //   setPaymentDetails(paymentDetails);
      //   setSuccessCheck(true);
      //   clearInterval(cryptoInterval);
      //   return;
      // }
      if (status?.state == "approved") {
        runTimerCheckRef.current = false;
        setRunTimerCheck(false);

        if (cryptoIntervalRef.current) {
          clearInterval(cryptoIntervalRef.current);
          cryptoIntervalRef.current = null;
        }

        setCountDown('');
        setShowQr(false);
        setShowForm(false);
        setPaymentDetails(paymentDetails);
        setSuccessCheck(true);
        return;
      }
    } catch (error) {
      console.log(error)

    }

  }
  const getStatusBreb = async (paymentDetails) => {
    /* let status = await API.GET.GetCryptoTransactionStatus(paymentDetails.GOrdenId, paymentDetails.method); */
    try {
      let status = await axios.post('/breb_status', { transactionID: paymentDetails.GOrdenId });
      status = status?.data?.data
      console.log('status: ', status, paymentDetails);
      setBrebStatus(status?.state);  // <--- GUARDAMOS EL ESTADO
      brebStatusRef.current = status?.state;

      if (status?.state == "COMPLETED") {
        console.log('Pago aprobado, cerrando QR.');
        setRunTimerCheckBreb(false)
        runTimerBrebRef.current = false
        setShowQr(false);
        setPaymentDetails(paymentDetails);
        setSuccessCheck(true);
        clearInterval(intervalBREB);
        return;
      }
    } catch (error) {
      console.log(error)

    }

  }
  // const GetAvaliableCriptoValues = async () => {
  //     try {
  //         let amount_ = cobru?.amount || getDigits(amount)
  //         if (params?.int === 'true') {
  //             let trmNew = null
  //             if (!trm) {
  //                 const res = await axios.post('/getSwapMoney', { amount: '10000' });
  //                 if (res?.data?.data && res?.status === 200) {
  //                     trmNew = res?.data?.data?.price
  //                 }
  //             }

  //             const TRM = trmNew ? trmNew : trm ? trm : ''
  //             amount_ = globalCurrency === 'USD' ?  (amount_/TRM) : amount_
  //         }
  //         setCurrencyAmount('Calculando...')
  //         console.log('GetAvaliableCriptoValues', AvaliableCriptoMethod());
  //         console.log('GetAvaliableCriptoValues', getDigits(amount_));
  //         if (AvaliableCriptoMethod() && (cobru?.amount || getDigits(amount))) {
  //             let currenciesCripto = await axios.post('/crypto_currencies_available', { amount:amount_ /* cobru?.amount || getDigits(amount) */, currency: payMethodName })
  //             console.log('res de currenciesCripto:', currenciesCripto)
  //             let arrayCryptos = currenciesCripto?.data?.data
  //             if (arrayCryptos) {
  //                 arrayCryptos.forEach(item => {
  //                     if (item.currency == payMethodName) {
  //                         //alert('ok')
  //                         setCurrencyAmount(item.amount)
  //                     }
  //                 });
  //             }
  //             console.log("CURRIENCIES CRIPTO:" + currencyAmount);
  //         }
  //     } catch (error) {
  //         setErrorMessage(translate('error_getting_crypto_value'))
  //         setCurrencyAmount('')

  //         console.log('GetAvaliableCriptoValues', error);
  //     }

  // }
  const getActiveCryptoPayment = (network = cryptoNetwork) => (
    payMethodName === 'USDT'
      ? (network || 'USDT')
      : payMethodName
  );
  const cryptoQuoteCurrency = 'USDT';

  const GetAvaliableCriptoValues = async (amountOverride = null) => {
    try {
      setError('')
      console.log("Iniciando GetAvaliableCriptoValues...");

      if (isBitppiAxi) {
        setCurrencyAmount('');
        return;
      }

      let amount_ = cobru?.amount || amountOverride || (isTengoPayment ? parseTengoUsdAmount(amount) : getDigits(amount));
      let trmNew = null;
      console.log('amount_:', amount_);

      if (!AvaliableCriptoMethod() || !amount_) {
        return
      }

      console.log("Monto inicial:", amount_);

      if (params?.int === 'true' && !isTengoPayment) {
        try {
          if (!trm) {
            console.log("Solicitando TRM...");
            const res = await axios.post('/getSwapMoney', { amount: '10000' });
            if (res?.data?.data && res?.status === 200) {
              trmNew = parseFloat(res?.data?.data?.price);
              console.log("TRM obtenida:", trmNew);
            } else {
              console.warn("Respuesta de TRM no válida:", res);
              throw new Error("No se pudo obtener una TRM válida.");
            }
          }
        } catch (trmError) {
          console.error("Error al obtener TRM:", trmError);
          throw new Error("No se pudo obtener la TRM.");
        }

        const TRM = trmNew || trm || 1;
        console.log("Usando TRM:", TRM);

        // Validar que TRM sea válida
        if (isNaN(TRM) || TRM <= 0) {
          throw new Error("La TRM obtenida no es válida: " + TRM);
        }

        if (globalCurrency === 'USD') {
          try {
            console.log("Convirtiendo USD a COP...");

            // Asegurar que amount_ sea válido
            amount_ = parseFloat(amount_);
            if (isNaN(amount_) || amount_ <= 0) {
              throw new Error("El monto ingresado no es válido: " + amount_);
            }

            let amountInCOP = Math.round(amount_ * TRM);
            console.log("Monto convertido a COP (redondeado):", amountInCOP);

            // Reconvertir a USD y redondear
            let adjustedAmountUSD = Math.round((amountInCOP / TRM) * 100) / 100;
            console.log("Monto reconvertido a USD:", adjustedAmountUSD);

            let difference = amount_ - adjustedAmountUSD;
            console.log("Diferencia tras reconversión:", difference);

            if (Math.abs(difference) > 0) {
              let correctionInCOP = Math.round(difference * TRM);
              console.log("Ajustando en COP:", correctionInCOP);
              amountInCOP += correctionInCOP;
            }

            amount_ = amountInCOP;
            console.log("Monto final después de ajuste:", amount_);
          } catch (conversionError) {
            console.error("Error en conversión de moneda:", conversionError);
            throw new Error("Error en la conversión de moneda.");
          }
        }
      }

      // Asegurar que el monto en COP tenga máximo dos decimales y sea redondeado
      amount_ = Math.round(amount_ * 100) / 100;
      console.log("Monto final con máximo 2 decimales:", amount_);

      setCurrencyAmount('Calculando...');

      if (!AvaliableCriptoMethod()) {
        console.warn("AvaliableCriptoMethod() es inválido.");
        throw new Error("Método de pago no válido.");
      }

      console.log("Consultando criptomonedas disponibles...");
      let currenciesCripto = await axios.post('/crypto_currencies_available', {
        amount: amount_,
        currency: cryptoQuoteCurrency,
        currency_code: isTengoPayment ? 'USD' : (cobru?.currency_code || 'COP')
      });

      console.log("Respuesta de currenciesCripto:", currenciesCripto?.data);

      let arrayCryptos = currenciesCripto?.data?.data;
      if (arrayCryptos) {
        let foundCrypto = arrayCryptos.find(item => item.currency === cryptoQuoteCurrency);
        if (foundCrypto) {
          const cryptoAmount =
            globalCurrency === 'USD'
              ? Math.round(foundCrypto.amount)
              : foundCrypto.amount;
          setCurrencyAmount(cryptoAmount);
          console.log("Monto cripto encontrado:", foundCrypto.amount);
        }
      }
    } catch (error) {
      console.error("Error general en GetAvaliableCriptoValues:", error);
      setErrorMessage(translate('error_getting_crypto_value'));
      setCurrencyAmount('');
    }
  };



  const getDaviplataStatus = async () => {
    try {
      setLoading(true)
      setErrorMessage('')
      if (!OTPNumber || !cobruURL_ || OTPNumber.length < 6) {
        console.log('invalid');
        setLoading(false)

        return
      }
      console.log({ url: cobruURL_, otp: OTPNumber });
      let status = await axios.post('/daviplata', { url: cobruURL_, otp: OTPNumber });
      if (status?.data?.status === 400) {
        setErrorMessage(status?.data?.data?.message)
        setRunTimerCheckDaviplata(false)
        clearInterval(daviplataInterval)
        setSuccessCheck(false)
        setLoading(false)

      } else if (status?.data?.data?.result == 'OK') {
        setRunTimerCheckDaviplata(false)
        setDaviplataInfo(status?.data?.data?.number_transaction)
        clearInterval(daviplataInterval)
        setShowForm(false)
        setSuccessCheck(true)
        setLoading(false)

      }
      setLoading(false)
      console.log('getDaviplataStatus: ', status);
    } catch (error) {
      console.log(error);
      setErrorMessage(translate('daviplata_status_error'))
      setLoading(false)

    }
  }


  useEffect(() => {
    setErrorMessage('')
  }, [payMethodName, formValues, amount])

  // useEffect(() => {
  //   GetAvaliableCriptoValues()
  //   if (payMethodName !== 'daviplata') {
  //      if (payMethodName === 'credit_card') {
  //           setDocumentTypes([...documentTypesArray, {
  //           label: `PA - Pasaporte`,
  //           label2: "PA",
  //           value: 4,
  //         },
  //         {
  //           label: `DNI - Documento Nacional de Identidad`,
  //           label2: "DNI",
  //           value: 8,
  //         },

  //       ])
  //       return
  //     }
  //     setDocumentTypes([...documentTypesArray, {
  //       label: `PA - Pasaporte`,
  //       label2: "PA",
  //       value: 4,
  //     },
  //     {
  //       label: `PPT - Permiso de Protección Temporal`,
  //       label2: "PPT",
  //       value: 5,
  //     }])
  //   } else {
  //     setDocumentItem(documentTypesArray[1])
  //     setDocumentTypes(documentTypesArray)
  //   }
  // }, [payMethodName])
  useEffect(() => {
    GetAvaliableCriptoValues();

    if (payMethodName !== "daviplata") {
      // Caso especial: tarjeta de crédito y país distinto de Colombia
      if (
        payMethodName === "credit_card" &&
        countryFull?.country_name &&
        countryFull?.country_name.toLowerCase() !== "colombia"
      ) {
        const newDocs = [
          {
            label: `DNI - Documento Nacional de Identidad`,
            label2: "DNI",
            value: 8,
          },
          {
            label: `PA - Pasaporte`,
            label2: "PA",
            value: 4,
          },
          ...documentTypesArray.filter(
            (d) => d.label2 !== "DNI" && d.label2 !== "PA"
          ),
        ];
        setDocumentTypes(newDocs);
        setDocumentItem(newDocs[0]); // Selecciona DNI automáticamente
        return;
      }

      // Caso normal: credit_card en Colombia u otros métodos
      if (payMethodName === "credit_card") {
        setDocumentTypes([
          ...documentTypesArray,
          {
            label: `PA - Pasaporte`,
            label2: "PA",
            value: 4,
          },
          {
            label: `DNI - Documento Nacional de Identidad`,
            label2: "DNI",
            value: 8,
          },
        ]);
        return;
      }

      // Resto de métodos de pago
      setDocumentTypes([
        ...documentTypesArray,
        {
          label: `PA - Pasaporte`,
          label2: "PA",
          value: 4,
        },
        {
          label: `PPT - Permiso de Protección Temporal`,
          label2: "PPT",
          value: 5,
        },
      ]);
    } else {
      setDocumentItem(documentTypesArray[1]);
      setDocumentTypes(documentTypesArray);
    }
  }, [payMethodName, countryFull]);

  useEffect(() => {
    if (!!buttonName && buttonName === 'USDT') {
      //console.log('useEffect');
      GetAvaliableCriptoValues(cobru?.amount || getDigits(amount))
    }
  }, [buttonName])


  const getIndicatiosPin = () => {
    if (payMethodName === 'efecty') {
      return translate('efecty_point_info')
    }
    if (payMethodName === 'corresponsal_bancolombia') {
      return translate('corresponsal_point_info')
    }
  }

  const AvaliableCriptoMethod = () => {
    console.log('payMethodName', payMethodName);
    return (
      payMethodName === 'BTC' ||
      payMethodName === 'BCH' ||
      payMethodName === 'DAI' ||
      payMethodName === 'DASH' ||
      payMethodName === 'USDT'
    );
  }
  const onChangeInput = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value })
  }
  const onChangeInputFormat = (e, formatPhone = false) => {
    if (formatPhone) {
      setFormValues({ ...formValues, [e.target.name]: formatPhoneNumber(e.target.value) })
      return
    }
    setFormValues({ ...formValues, [e.target.name]: formatDocument(e.target.value) })
  }

  // const QueryIP = async (IP) => {

  //     try {
  //         setLoadingIpInfo(true)
  //         const URL = 'https://panel.validu.co'
  //         const x_api_key = '7oa71voJ.4gFO1Bul2aOS3zfpd9ARvIeeFofPQL0I'
  //         let headers = {
  //             Accept: 'application/json',
  //             'x-api-Key': x_api_key,
  //             "Content-Type": 'application/json',
  //             'Authorization': "Bearer " + await GetAccessTokenValidu()
  //         }
  //         console.log('url QueryIP:', `${URL}/api/ip_validation/?ip=${IP}`);
  //         console.log('headers QueryIP:', headers);
  //         //return
  //         let response = await axios.get(`${URL}/api/ip_validation/?ip=${IP}`, { headers });

  //         console.log('response QueryIP:', response?.data);

  //         if (response.status === 200 && response?.data?.data) {

  //             setIpInfo(response?.data?.data?.data)
  //             console.log('HOLAL ', response?.data?.data?.data);
  //             setCity({
  //                 label: response?.data?.data?.data?.city || ''
  //             })
  //             setState({
  //                 label: response?.data?.data?.data?.regionName || ''
  //             })
  //             //return await response?.data;
  //             setLoadingIpInfo(false)
  //         }

  //     } catch (error) {
  //         console.error('QueryIP error: ', error.response?.data);
  //         if (error.response?.data) {
  //             setLoadingIpInfo(false)
  //             return error.response?.data

  //         }
  //         setLoadingIpInfo(false)
  //         return { "message": error, "error": true }

  //     }


  // }
  //old
  // const onChangeBTNName = (item, newLabelAmount = '') => {
  //   console.log('onChangeBTNName:', Object.keys(item)[0] === 'USDT');
  //   setShowOTP(false)
  //   setCurrencyAmount('')
  //   setQrValue(null)
  //   let name = 'Pagar';
  //   switch (Object.keys(item)[0]) {
  //     case 'credit_card':
  //       let amount_ = ''
  //       let amountLabel = ''
  //       /* if (!!newAmount) {
  //           amount_=newAmount

  //       } else {
  //           //const amount_ =  (!!params && params?.amount && params?.isInt === 'true' && params?.currency?.toString()?.toLowerCase() === 'usd') ? params?.amount : globalCurrency == 'COP'? amount ? amount : '0' : ''
  //            amount_ =  (!!params && params?.amount) ? params?.amount :  amount ? amount : '0'
  //            //amountLabel = (!!params && params?.currency?.toString()?.toLowerCase() === 'usd') ? formatUSD(amount_, true)+' USD' :formatCOPNumber(amount_, true)+ ' COP'

  //       }

  //       if (!!newAmount) {
  //           amountLabel= amount_+ ' COP'
  //       } else {

  //           amountLabel =(globalCurrency === 'USD' || (!!params && params?.currency.toString().toLowerCase() === 'usd')) ? formatUSD(amount_, true)+' USD' :formatCOPNumber(amount_, true)+ ' COP'
  //       } */
  //       if (!!newLabelAmount) {
  //         amountLabel = newLabelAmount
  //       } else {

  //         amount_ = (!!params && params?.amount) ? params?.amount : amount ? amount : !!cobru?.amount ? cobru?.amount : '0'
  //         console.log(amount_);
  //         if (cobru?.amount) {
  //           amountLabel = ((formatCOPNumber((cobru?.amount)))
  //           );

  //         } else {


  //           amountLabel = (!!params && params?.currency?.toString()?.toLowerCase() === 'usd') ? formatUSD(amount_, true) + ' USD' : formatCOPNumber(amount_, true) + ' COP'
  //           console.log('onChangeBTNName globalCurrency: ', amount_);
  //         }
  //       }
  //       let labelPagar = translate('pay_text')
  //       //let labelPagar = !!params && params?.int === 'true' ? 'Pay ' : 'Pagar '
  //       name = labelPagar + amountLabel;
  //       break;
  //     case 'NEQUI':
  //       name = translate('pay_with') + 'Nequi';
  //       break;
  //     case 'breb':
  //       name = 'Ver LLave ' + 'Bre-B';
  //       // name = translate('pay_with') + 'Bre-B';
  //       break;
  //     case 'daviplata':
  //       name = translate('pay_with') + 'Daviplata';
  //       break;
  //     case 'corresponsal_bancolombia':
  //       name = translate('pay_with') + 'Corresponsal';
  //       break;
  //     case 'bancolombia_transfer':
  //       name = translate('pay_with') + 'Botón Bancolombia';
  //       break;
  //     case 'bancolombiapay':
  //       name = translate('pay_with') + 'Bancolombia pay';
  //       break;
  //     case 'pse':
  //       name = translate('pay_with') + 'PSE';
  //       break;
  //     case 'dale':
  //       name = translate('pay_with') + 'Dale';
  //       break;
  //     case 'efecty':
  //       name = translate('pay_with') + 'Efecty';
  //       break;
  //     case 'BTC':
  //       name = translate('pay_with') + 'BTC';
  //       break;
  //     case 'CUSD':
  //       name = translate('pay_with') + 'CUSD';
  //       break;
  //     case 'cobru':
  //       let currentUrl = window.location.href;
  //       const parsedUrl = new URL(currentUrl);
  //       setQrValue(`${parsedUrl?.origin}${parsedUrl?.pathname}`)
  //       name = `${translate('pay_with')} ${isPagaHoy ? 'Paga Hoy' : 'Cobru'}`;
  //       break;
  //     case 'bancolombia_qr':
  //       name = translate('pay_with') + 'QR Bancolombia';
  //       break;
  //     case 'USDT':
  //       name = translate('pay_with') + 'USDT';
  //       GetAvaliableCriptoValues()
  //       break;
  //     case 'DAI':
  //       name = translate('pay_with') + 'DAI';
  //       break;
  //     case 'baloto':
  //       name = translate('pay_with') + 'Baloto';
  //       break;
  //     case 'DASH':
  //       name = translate('pay_with') + 'DASH';
  //       break;
  //     case 'BCH':
  //       name = translate('pay_with') + 'BCH';
  //       break;
  //     case 'tpaga':
  //       name = translate('pay_with') + 'TPAGA';
  //       break;
  //     case 'credit_card_international':
  //       name = translate('pay_with') + 'Credit Card International';
  //       break;
  //     case 'safetypay':
  //       name = translate('pay_with') + 'Safetypay';
  //       setGlobalCurrency('USD')
  //       break;
  //     default:
  //       name = translate('pay_text');
  //       break;
  //   }
  //   setButtonName(name)
  //   return name;
  // }
  const onChangeBTNName = (item, newLabelAmount = '') => {

    const methodName = Object.keys(item || {})[0];
    const isInternational = params?.int === true || params?.int === 'true';
    // reset crypto network
    if (methodName !== 'USDT') {
      setCryptoNetwork('USDT');
    } else if (isTengoPayment) {
      setCryptoNetwork(getTengoCryptoNetworks(paymentsMethod)[0] || 'USDT');
    }
    // Nuevo: solo para USDT internacional
    if (methodName === 'USDT' && isInternational) {
      setShowOTP(false);
      setCurrencyAmount('');
      setQrValue(null);
      setButtonName('Pagar USDT');
      GetAvaliableCriptoValues();
      return 'Pagar USDT';
    }

    console.log('onChangeBTNName:', Object.keys(item)[0] === 'USDT');
    setShowOTP(false)
    setCurrencyAmount('')
    setQrValue(null)
    let name = 'Pagar';

    switch (Object.keys(item)[0]) {
      case 'credit_card':
        let amount_ = ''
        let amountLabel = ''
        if (!!newLabelAmount) {
          amountLabel = newLabelAmount
        } else {
          amount_ = (!!params && params?.amount) ? params?.amount : amount ? amount : !!cobru?.amount ? cobru?.amount : '0'
          console.log(amount_);
          if (cobru?.amount) {
            amountLabel = ((formatCOPNumber((cobru?.amount))));
          } else {
            // Si viene `int=true`, el botón de tarjeta debe mostrarse en USD
            amountLabel = (isInternational || (!!params && params?.currency?.toString()?.toLowerCase() === 'usd'))
              ? formatUSD(amount_, true) + ' USD'
              : formatCOPNumber(amount_, true) + ' COP'
            console.log('onChangeBTNName globalCurrency: ', amount_);
          }
        }
        let labelPagar = isInternational ? translate('pay_with') : translate('pay_text')
        name = labelPagar + amountLabel;
        break;

      case 'NEQUI':
        name = translate('pay_with') + 'Nequi';
        break;

      case 'breb':
        name = 'Ver LLave ' + 'Bre-B';
        break;

      case 'daviplata':
        name = translate('pay_with') + 'Daviplata';
        break;

      case 'corresponsal_bancolombia':
        name = translate('pay_with') + 'Corresponsal';
        break;

      case 'bancolombia_transfer':
        name = translate('pay_with') + 'Botón Bancolombia';
        break;

      case 'bancolombiapay':
        name = translate('pay_with') + 'Bancolombia pay';
        break;

      case 'pse':
        name = translate('pay_with') + 'PSE';
        break;

      case 'dale':
        name = translate('pay_with') + 'Dale';
        break;

      case 'efecty':
        name = translate('pay_with') + 'Efecty';
        break;

      case 'BTC':
        name = translate('pay_with') + 'BTC';
        break;

      case 'CUSD':
        name = translate('pay_with') + 'CUSD';
        break;

      case 'cobru':
        let currentUrl = window.location.href;
        const parsedUrl = new URL(currentUrl);
        setQrValue(`${parsedUrl?.origin}${parsedUrl?.pathname}`)
        name = `${translate('pay_with')} ${isTengo ? 'Tengo' : isPagaHoy ? 'Paga Hoy' : 'Cobru'}`;
        break;

      case 'bancolombia_qr':
        name = translate('pay_with') + 'QR Bancolombia';
        break;

      case 'USDT':
        name = translate('pay_with') + 'USDT';
        GetAvaliableCriptoValues()
        break;

      case 'DAI':
        name = translate('pay_with') + 'DAI';
        break;

      case 'baloto':
        name = translate('pay_with') + 'Baloto';
        break;

      case 'DASH':
        name = translate('pay_with') + 'DASH';
        break;

      case 'BCH':
        name = translate('pay_with') + 'BCH';
        break;

      case 'tpaga':
        name = translate('pay_with') + 'TPAGA';
        break;

      case 'credit_card_international':
        name = translate('pay_with') + 'Credit Card International';
        break;

      case 'safetypay':
        name = translate('pay_with') + 'Safetypay';
        setGlobalCurrency('USD')
        break;

      default:
        name = translate('pay_text');
        break;
    }

    setButtonName(name)
    return name;
  }
  const validateInput = () => {

    try {

      const amountInput = () => {
        if (globalCurrency === 'USD' || (!!params && params?.currency?.toString().toLowerCase() === 'usd')) {
          console.log('if uno');

          //alert('ok')
          /* console.log('OK', (getDigitsRegister(amount) * trm),cobru?.min);
          if ((getDigitsRegister(amount) * trm) < cobru?.min) {
              setErrorMessages({ ...errorMessages, amount: 'El monto minimo es de ' + formatCOPNumber(cobru?.min) })
              return false
          }
          if ((getDigitsRegister(amount) * trm) > cobru?.max) {
 
              setErrorMessages({ ...errorMessages, amount: 'El monto maximo es de ' + formatCOPNumber(cobru?.max) })
              return false
          }
          if ((getDigitsRegister(amount) * trm) <= cobru?.max && getDigitsRegister(amount) >= cobru?.min) {
              setErrorMessages({ ...errorMessages, amount: '' })
              return true
          }
          return */
        }
        if (getDigitsRegister(amount) < cobru?.min) {
          if (USDPayments()) {
            return true
          }
          console.log('if 2');

          let message = translate('min_amount')
          setErrorMessages({ ...errorMessages, amount: message + formatCOPNumber(cobru?.min) })
          return false
        }
        if (getDigitsRegister(amount) > cobru?.max) {
          if (USDPayments()) {
            return true
          }

          let message = translate('max_amount')
          console.log('if 3');

          setErrorMessages({ ...errorMessages, amount: message + formatCOPNumber(cobru?.max) })
          return false
        }
        if (getDigitsRegister(amount) <= cobru?.max && getDigitsRegister(amount) >= cobru?.min) {
          console.log('if 4');

          setErrorMessages({ ...errorMessages, amount: '' })
          return true
        }
      }
      const nameInput = () => {
        if (!validateName(formValues?.name, !!params && params?.int === 'true' ? true : false)) {
          setErrorMessages({ ...errorMessages, name: nameErrorMessage })
          console.log('if 5');

          return false
        } else {
          setErrorMessages({ ...errorMessages, name: '' })
          return true
        }
      }

      const docInput = () => {
        if (getDigitsRegister(formValues?.doc) < 6) {
          console.log('if 6', formValues);

          setErrorMessages({ ...errorMessages, doc: documentErrorMessage })
          return false
        } else {
          setErrorMessages({ ...errorMessages, doc: '' })

          return true
        }
      }
      const emailInput = () => {
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formValues?.email)) {
          setErrorMessages({ ...errorMessages, email: emailErrorMessage })
          //setErrorMessages({ ...errorMessages, email: '¡Has ingresado una dirección de correo electrónico no válida!' })
          return false
        } else {
          setErrorMessages({ ...errorMessages, email: '' })
          return true
        }
      }
      const phoneInput = () => {
        if (formValues.phone.replace(/\D/g, "").length < 6) {
          console.log('if 7');

          setErrorMessages({ ...errorMessages, phone: translate('phone_number_error') })
          return false
        } else {
          setErrorMessages({ ...errorMessages, phone: '' })
          return true
        }
      }
      return {
        amountInput,
        nameInput,
        docInput,
        emailInput,
        phoneInput,
        all: (withPhone = false) => {
          let validations = nameInput() && docInput() && emailInput() && phoneInput()
          if (withPhone) {
            validations = validations && amountInput()
          }
          return validations
        }
      }

    } catch (error) {
      console.log('error validate inputs', error);
    }
  }
  const validateDataBasic = () => {
    /*      console.log('que es', formValues?.name);
            console.log('que es', payMethodName);
            console.log('que es', formValues?.doc);
            console.log('que es', formValues?.email);
            console.log('que es', formValues?.phone); */
    //')
    let disabled = false
    if (showPhoneCobru && formValues?.phone && amount) {
      console.log('showPhoneCobru');
      return disabled = false

    }
    if (!formValues?.name || !payMethodName || !formValues?.doc || !formValues?.email || !formValues?.phone) {
      /* console.log('primera'); */
      //console.log('segundo if');

      disabled = true
    }
    if (payMethodName === 'pse' && bankPse.value === '') {
      /*  console.log('2'); */
      //console.log('tercer if');

      disabled = true
    }
    if (payMethodName === 'credit_card') {
      if (creditCardNumber.replace(/\D/g, "").length < 13 || creditCardDate.length < 5 || creditCardCVV.length < 3) {
        disabled = true
        /* console.log('3'); */
      }
      //console.log('4 if');

    }
    if (isAPhone) {
      //console.log('errorMessages: ', errorMessages);

      if (errorMessages.amount !== '') {
        disabled = true
        //console.log('errorMessages:errorMessages');

      }
      if (params?.amount) {
        disabled = false
      }
      //console.log('5 if');


    }

    if (loading) {
      disabled = true

    }
    //console.log('que es disabled', disabled);
    return disabled
  }
  // Tabs de red deben mostrarse apenas se elige USDT (antes de generar QR).
  const showUsdtTabs = payMethodName === 'USDT';
  const brandAccent = isBitppiAxi ? AXI_ACCENT : getBrandAccentColor();
  const walletPreview = qrValue && qrValue.length > 31
    ? `${qrValue.substring(0, 20)}...${qrValue.substring(qrValue.length - 8)}`
    : qrValue;
  const handleCopyWallet = () => {
    copyClipbord(qrValue, () => {
      setWalletCopied(true);
      if (walletCopiedTimeoutRef.current) {
        clearTimeout(walletCopiedTimeoutRef.current);
      }
      walletCopiedTimeoutRef.current = setTimeout(() => {
        setWalletCopied(false);
        walletCopiedTimeoutRef.current = null;
      }, 3000);
    });
  };
  const axiQrRawAmount = amount || params?.amount || cobru?.amount || '';
  const axiQrDisplayAmount = String(axiQrRawAmount).trim().startsWith('$')
    ? axiQrRawAmount
    : `$${axiQrRawAmount}`;
  const enabledCryptoTabs = (() => {
    const tabs = isTengoPayment && !getTengoCryptoNetworks(paymentsMethod).includes('USDT')
      ? []
      : [{ id: 'USDT', label: 'TRON' }];
    const ethEnabled = !!(paymentsMethod?.ETH || paymentsMethod?.eth);
    const polygonEnabled = !!(paymentsMethod?.POLYGON || paymentsMethod?.polygon);
    if (ethEnabled) tabs.push({ id: 'ETH', label: 'ETHEREUM' });
    if (polygonEnabled) tabs.push({ id: 'POLYGON', label: 'POLYGON' });
    return tabs;
  })();
  const showCryptoNetworkTabs = showUsdtTabs && enabledCryptoTabs.length > 1;
  const receiptReference =
    cobru?.id ??
    cobru?.pk ??
    cobruItemBack?.pk ??
    paymentDetails?.pk ??
    paymentDetails?.ordenId;
  const isCurrencyAmountPending =
    currencyAmount === 'Calculando...' ||
    currencyAmount === `${translate("calculating_text")}...`;
  const cryptoReceiptAmountFallback =
    paymentDetails?.currency_amount ??
    paymentDetails?.crypto_amount ??
    paymentDetails?.amount_crypto ??
    paymentDetails?.amount_usdt ??
    paymentDetails?.amount_to_pay ??
    '';
  const cryptoReceiptAmount =
    !isCurrencyAmountPending && (currencyAmount || currencyAmount === 0)
      ? currencyAmount
      : cryptoReceiptAmountFallback;

  useEffect(() => {
    if (!showUsdtTabs) return;
    const allowed = new Set(enabledCryptoTabs.map((t) => t.id));
    if (!allowed.has(cryptoNetwork)) {
      setCryptoNetwork(enabledCryptoTabs[0]?.id || 'USDT');
    }
  }, [showUsdtTabs, paymentsMethod, cryptoNetwork]);

  if (!showCobru) {
    return (
      <div className="flex justify-end items-end">
        <p className="text-center">{translate('cobru_not_exist_error')}</p>
      </div>
    )
  }
  //console.log(cobru);


  const formatUSD = (value, isShow = false) => {
    if (!value || value === '$') {
      setAmount('')
      return ''
    }
    // Elimina todos los caracteres que no sean dígitos o el punto decimal
    const cleanedValue = value.replace(/[^\d.]/g, '');

    // Divide el valor en dólares y centavos
    const [dollars, cents] = cleanedValue.split('.');

    // Formatea los dólares con comas
    const formattedDollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Limita los centavos a dos dígitos
    const formattedCents = cents ? `.${cents.slice(0, 2)}` : '';

    // Combina los dólares y centavos formateados
    const formattedValue = `$${formattedDollars}${formattedCents}`;
    if (isShow) {
      return formattedValue
    }
    console.log('formatUSD:', formattedValue);

    // Actualiza el estado con el valor formateado
    setAmount(formattedValue);
  };

  //console.log('isPhoneNumber: ',isPhoneNumber);
  if (showCanceledModal) {
    return (
      <Modal2 onClose={() => {
        window.location.replace(window.location.href);

      }}>
        <div style={{ textAlign: "center", padding: "25px 15px" }}>
          <h2 style={{ color: "red" }}>Pago Cancelado</h2>
          <p>El tiempo venció y no se recibió confirmación.</p>

          <button
            onClick={() => {
              setShowCanceledModal(false);
              setShowQr(false);
              setShowForm(true);
            }}
            style={{
              marginTop: 15,
              backgroundColor: "#000",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: 10,
              cursor: "pointer",
            }}
          >
            Volver
          </button>
        </div>
      </Modal2>

    )

  }
  return (
    <div className="flex items-center justify-start flex-col">

      <NavBarCobru />
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
      {/*header full*/}
      <CobruNavBar cobru={cobru} loading={loading} error={error} fullCobru={cobruItemBack} reference={receiptReference} />
      {/*  */}
      <div className="bg-main w-full flex justify-center">
        <div className="flex flex-col justify-center items-center container-data">
          <div className="flex flex-col justify-center items-start w-full">
            <UserNameComponent
              cobruInfo={
                !!params && params?.title
                  ? params?.title
                  : cobru
                    ? cobru?.alias
                    : ""
              }
            />
            {params?.amount && <SplitAmount cobru={params} />}
            {
              cobru?.amount && !params?.amount && payMethodName !== 'USDT' && (
                <SplitAmount cobru={cobru} />
              )

              /*  <p className="price-tag">{`${cobru?.amount ? formatCOPNumber(cobru?.amount, true) : ''}`}</p> */
            }
            {/* {cobru?.amount &&
                cobru?.currency_code === "USD" &&
                !USDPayments() &&
                trm && (
                  <div className="mt-2">
                    <SplitAmount
                      cobru={{
                        amount: parseInt(cobru?.amount) * trm,
                      }}
                    />
                  </div>
                )} */}

            {AvaliableCriptoMethod() &&
              (currencyAmount || currencyAmount === 0) &&
              (!!amount || cobru?.amount || params?.amount) && (
                <p className="price-tag my-4">
                  {currencyAmount}{" "}
                  {currencyAmount !== translate("calculating_text") + "..."
                    ? cryptoQuoteCurrency
                    : ""}
                </p>
              )
            }
            {isBitppiAxi && showQr && !showForm && !!axiQrRawAmount && (
              <p className="price-tag price-tag-axi my-4">
                {axiQrDisplayAmount} USD
              </p>
            )}
            {!!params &&
              params?.amount &&
              params?.quantity === 'true' &&
              (params?.int !== "true" || !params?.int) && (
                <div className="flex items-start flex-row justify-between w-full mt-3">
                  <p className="price-tag">{`${params?.amount
                    ? formatCOPNumberInput(params?.amount * quantity, true)
                    : ""
                    }`}</p>
                  <p className="w-1/2"></p>
                  <div className="flex items-start flex-row h-10">
                    <button
                      onClick={() => {
                        setQuantity((e) => {
                          return e > 1 ? e - 1 : 1;
                        });
                      }}
                      className="quantity_button w-5"
                      style={isTengo ? { backgroundColor: brandAccent } : undefined}
                    >
                      -
                    </button>
                    <p className="mx-6 w-5 ">{quantity}</p>
                    <button
                      onClick={() => {
                        setQuantity((e) => e + 1);
                      }}
                      className="quantity_button w-5"
                      style={isTengo ? { backgroundColor: brandAccent } : undefined}
                    >
                      +
                    </button>
                  </div>
                </div>
              )}
          </div>
          <div className="flex justify-center flex-col items-center w-full ">

            <div className="w-full">
              <p className="my-5 text-center">
                {!!params && params?.int === "true"
                  ? ""
                  : translate("choose_payment_method_label")}
              </p>

              <Carousel
                paymentsMethodArray={paymentsMethodArray}
                paymentsMethod={paymentsMethod}
                currentPaymentMethod={currentPaymentMethod}
                accentColor={isBitppiAxi ? AXI_ACCENT : null}
                onClickItem={(item) => {
                  resetData();
                  setCurrentPaymentMethod(item);
                  onChangeBTNName(item);
                  setShowForm(true);
                  setShowQr(false);
                  setShowPin(false);
                  setSuccessCheck(false);
                  setWaitingNequiPay(false);
                  setShowOTP(false);
                }}
              />
              {showCryptoNetworkTabs && (
                <div className="w-full mt-5 flex justify-center">
                  <div className="w-full flex gap-2">
                    {enabledCryptoTabs.map((tab) => (
                      <button
                        key={tab.id}
                        type="button"
                        onClick={() => {
                          setCryptoNetwork(tab.id);
                          GetAvaliableCriptoValues();
                          // Espera 3s antes de disparar getDetailsPay, con loading inmediato
                          scheduleUsdtNetworkRefresh(tab.id);
                        }}
                        style={cryptoNetwork === tab.id ? { borderColor: brandAccent, color: brandAccent } : undefined}
                        className={`flex-1 px-4 py-2 rounded-xl whitespace-nowrap text-sm font-medium transition-all border bg-transparent ${cryptoNetwork === tab.id
                          ? ''
                          : 'text-gray-600 border-gray-300'
                          }`}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {showForm ? (
              <div className="w-full mt-5">
                {!showOTP && (
                  <div className="flex items-center flex-col w-full">
                    {params?.amount ? (
                      <></>
                    ) : (
                      isPhoneNumber &&
                      (!params?.amount || params?.int || showPhoneCobru) && (
                        //isPhoneNumber && (!params?.amount && (!params?.int || params?.int !== 'true')) &&
                        <div className="w-full">
                          <Input
                            inputMode="decimal"
                            amountSelector={
                              isTengoPayment ||
                                isBitppi72342403Layout ||
                                params?.multicurrency === "false"
                                ? false
                                : (payMethodName === "credit_card" ||
                                  payMethodName === "USDT") &&
                                !!params &&
                                params?.int === "true"
                            }
                            // amountSelector={((payMethodName === 'credit_card' || payMethodName == 'USDT') && (!!params && params?.int === 'true')) ? true : false}
                            options={amountOptions}
                            optionValue={globalCurrency}
                            onChangeValue={async (e) => {
                              setGlobalCurrency(e.target.value);

                              if (params?.amount) {
                                setAmount("");
                              }
                              if (
                                !!params &&
                                params?.int === "true" &&
                                !params?.amount &&
                                amount &&
                                e?.target?.value === "USD"
                              ) {
                                //console.log('onChangeValue');
                                let amaount__ = amount;
                                setAmount("");
                                let trmNew = null;
                                if (!trm) {
                                  const res = await axios.post(
                                    "/getSwapMoney",
                                    { amount: "10000" }
                                  );
                                  if (
                                    res?.data?.data &&
                                    res?.status === 200
                                  ) {
                                    trmNew = res?.data?.data?.price;
                                  }
                                }

                                const TRM = trmNew ? trmNew : trm ? trm : "";
                                const amount_new =
                                  parseFloat(getDigitsRegister(amaount__)) /
                                  parseInt(TRM);
                                console.log(
                                  "amount_new: ",
                                  parseInt(amount_new)
                                );

                                setAmount(
                                  formatUSD(
                                    parseFloat(amount_new).toString(),
                                    true
                                  )
                                );
                                //alert('USD')
                                onChangeBTNName(
                                  {
                                    credit_card: true,
                                    index: 7,
                                    available: true,
                                  },
                                  formatUSD(amount_new.toString(), true) +
                                  ` ${e?.target?.value}`
                                );

                                setTimeout(() => {
                                  validateMaxMinUSD(amount_new);
                                }, 500);
                              }
                              if (
                                !!params &&
                                params?.amount &&
                                e?.target?.value === "USD"
                              ) {
                                console.log("onChangeValue");

                                setAmount(formatUSD(params?.amount, true));
                                onChangeBTNName(
                                  {
                                    credit_card: true,
                                    index: 7,
                                    available: true,
                                  },
                                  formatUSD(params?.amount, true) +
                                  ` ${e?.target?.value}`
                                );

                                setTimeout(() => {
                                  validateMaxMinUSD(params?.amount);
                                }, 500);
                              }
                              if (
                                !!params &&
                                params?.int === "true" &&
                                !params?.amount &&
                                amount &&
                                e?.target?.value == "COP"
                              ) {
                                console.log("aca", amount);
                                let trmNew = null;
                                if (!trm) {
                                  const res = await axios.post(
                                    "/getSwapMoney",
                                    { amount: "10000" }
                                  );
                                  if (
                                    res?.data?.data &&
                                    res?.status === 200
                                  ) {
                                    trmNew = res?.data?.data?.price;
                                  }
                                }

                                const TRM = trmNew ? trmNew : trm ? trm : "";
                                console.log("TRM", TRM);
                                console.log(
                                  "GETD",
                                  getDigitsRegister(amount)
                                );
                                const amount_new = parseFloat(
                                  getDigitsRegister(amount) * parseInt(TRM)
                                );
                                console.log(amount_new);
                                setAmount(
                                  formatCOPNumberInput(
                                    parseInt(amount_new),
                                    true
                                  )
                                );
                                onChangeBTNName(
                                  {
                                    credit_card: true,
                                    index: 7,
                                    available: true,
                                  },
                                  formatCOPNumberInput(
                                    parseInt(amount_new),
                                    true
                                  ) + ` ${e?.target?.value}`
                                );
                                setTimeout(() => {
                                  validateMaxMinCop(parseInt(amount_new));
                                }, 500);
                                // setAmount(formatCOPNumberInput(getDigitsRegister(params?.amount) * parseFloat(trm), true));
                              }

                              if (
                                trm &&
                                !!params &&
                                params?.amount &&
                                e?.target?.value == "COP"
                              ) {
                                const amount_new = parseFloat(
                                  getDigitsRegister(
                                    parseFloat(params?.amount)
                                  ) * parseFloat(trm)
                                );
                                console.log(amount_new);
                                setAmount(
                                  formatCOPNumberInput(
                                    parseInt(amount_new),
                                    true
                                  )
                                );
                                onChangeBTNName(
                                  {
                                    credit_card: true,
                                    index: 7,
                                    available: true,
                                  },
                                  formatCOPNumberInput(
                                    parseInt(amount_new),
                                    true
                                  ) + ` ${e?.target?.value}`
                                );
                                setTimeout(() => {
                                  validateMaxMinCop(parseInt(amount_new));
                                }, 500);
                                // setAmount(formatCOPNumberInput(getDigitsRegister(params?.amount) * parseFloat(trm), true));
                              }
                              //console.log();
                              //setAmount('')
                              setErrorMessages({
                                amount: "",
                                name: "",
                                docType: "",
                                doc: "",
                                email: "",
                                phone: "",
                              });
                              //amount: '')
                              console.log("jeje aca");
                              setGlobalCurrency(e.target.value);
                            }}
                            value={amount}
                            errorMessage={errorMessages.amount}
                            placeholder="$0"
                            onChange={(value) => {
                              console.log("onChange:", value);

                              if (globalCurrency === "COP") {
                                setAmount(formatCOPNumberInput(value));
                              } else {
                                formatUSD(value);
                              }
                            }}
                            onBlur={() => {
                              console.log("onBlur");

                              validateInput().amountInput();
                              GetAvaliableCriptoValues();
                              if (
                                !!params &&
                                params?.int == "true" &&
                                payMethodName == "credit_card"
                              ) {
                                let amountText = "";
                                let amount_ = params?.amount
                                  ? params?.amount
                                  : amount
                                    ? getDigitsRegister(amount)
                                    : "";
                                if (globalCurrency === "COP") {
                                  amountText = formatCOPNumberInput(amount_);
                                  console.log("amountText cop:", amountText);
                                } else {
                                  amountText = formatUSD(amount_, true);
                                  console.log("amountText usd:", amountText);
                                }

                                console.log(amount_, globalCurrency);
                                setTimeout(() => {
                                  onChangeBTNName(
                                    {
                                      credit_card: true,
                                      index: 7,
                                      available: true,
                                    },
                                    amountText + " " + globalCurrency
                                  );
                                }, 500);
                              } else if (payMethodName == "credit_card") {
                                console.log("onChangeBTNName cd ");

                                onChangeBTNName(
                                  {
                                    credit_card: true,
                                    index: 7,
                                    available: true,
                                  },
                                  formatCOPNumberInput(
                                    getDigitsRegister(amount),
                                    true
                                  )
                                );
                              }
                            }}
                            rate={isBitppi72342403Layout ? '' : trm}
                            className={"!text-3xl font-semibold"}
                            //className={(payMethodName !== 'credit_card'/*  && (!!params && params?.int === 'true') */) ? '!text-3xl font-semibold ' : ""}
                            disabled={
                              !!params && params?.amount ? true : false
                            }
                          />
                          {/*  <input value={amount} onChange={(e) => {
                                                    
                                                }} className="payment-input h-14 text-4xl " placeholder="$0" /> */}
                        </div>
                      )
                    )}
                    {payMethodName === "credit_card" && !isGateway24 ? (
                      <>
                        {!!params && !!params?.int === "true" && (
                          <Input
                            errorMessage={errorMessages.name}
                            name="cc-name"
                            value={formValues.name}
                            placeholder={fullNamePlaceholder}
                            onChange={(value) =>
                              setFormValues({ ...formValues, name: value })
                            }
                            onBlur={() => {
                              validateInput().nameInput();
                            }}
                            autocomplete="cc-name"
                          />
                        )}

                        <Input
                          maxlength={"20"}
                          required={true}
                          autocomplete="cc-number"
                          pattern="[0-9]*"
                          type="text"
                          name="cc-number"
                          placeholder={
                            translate(
                              "card_number_label"
                            ) /* !!params && params?.int === 'true'?'Card number' :"Número de la tarjeta" */
                          }
                          value={creditCardNumber}
                          onChange={(value) => {
                            setCreditCardNumber(FormatCreditCard(value));
                          }}
                        />
                        <div className="flex flex-row ">
                          <div className="w-2/3">
                            <Input
                              type="text"
                              inputMode="numeric"
                              autocomplete="cc-exp"
                              className="payment-input"
                              placeholder={
                                translate(
                                  "month_card_label"
                                ) /* !!params && params?.int === 'true'? 'MM/YY':"MM/AA" */
                              }
                              name="cc-exp"
                              value={creditCardDate}
                              onChange={(value) => {
                                const inputValue = value;
                                setCreditCardDate(
                                  FormatExpirationDate(inputValue)
                                );
                              }}
                            />
                          </div>
                          <div className="mr-3" />
                          <div className="w-2/3">
                            <input
                              type="text"
                              inputMode="numeric"
                              autoComplete="cc-csc"
                              name="cc-csc"
                              className="payment-input"
                              maxLength={"3"}
                              pattern="[0-9]*"
                              placeholder="CVV"
                              value={creditCardCVV}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                const cleanedValue = inputValue.replace(
                                  /\D/g,
                                  ""
                                );
                                if (
                                  getFranchise(
                                    creditCardNumber
                                      .toString()
                                      .replace(/\D/g, "")
                                  ) === "American Express"
                                ) {
                                  if (inputValue.length < 5) {
                                    setCreditCardCVV(inputValue);
                                  }
                                  return;
                                }
                                if (inputValue.length < 4) {
                                  setCreditCardCVV(inputValue);
                                }
                              }}
                            />
                          </div>
                          <div className="mr-3" />

                          <SelectModal
                            items={cuotas}
                            selectedItem={creditCardCuotas}
                            setSelectItem={setCreditCardCuotas}
                          />
                        </div>
                      </>
                    ) : null}
                    {!!params &&
                      params?.int === "true" &&
                      payMethodName === "credit_card" ? (
                      <>
                        <div className="flex flex-row w-full">
                          <div className={"w-4/6 mr-3"}>
                            <SelectModal
                              items={countries_new}
                              selectedItem={country}
                              setSelectItem={setCountry}
                              customLabelKey="label2"
                            />
                          </div>
                          <div className="w-full">
                            <Input
                              type="tel"
                              name="phone"
                              value={formValues.phone}
                              onChange={(e) => {
                                setFormValues({
                                  ...formValues,
                                  phone: formatPhoneNumber(e),
                                });
                              }}
                              errorMessage={errorMessages.phone}
                              placeholder={
                                translate(
                                  "phone_number_label"
                                ) /* !!params && params?.int === 'true' ? 'Phone number': "Número de celular" */
                              }
                              onBlur={() => validateInput().phoneInput()}
                              autocomplete="tel-national"
                            />
                          </div>
                        </div>
                      </>
                    ) : payMethodName == "cobru" ? (
                      <></>
                    ) : (
                      <>
                        <Input
                          errorMessage={errorMessages.name}
                          name="name"
                          value={formValues.name}
                          disabled={hasPrefilledBitppiField(params?.name)}
                          placeholder={fullNamePlaceholder}
                          onChange={(value) =>
                            setFormValues({ ...formValues, name: value })
                          }
                          onBlur={() => {
                            validateInput().nameInput();
                          }}
                          autocomplete="name"
                        />

                        {(params?.int !== "true" || isBitppi72342403Layout) && (
                          <div className="flex items-start w-full">
                            {!isBitppi72342403Layout && (
                              <div className="w-2/5 mr-3">
                                <SelectModal
                                  customLabelKey="label2"
                                  items={documentTypes}
                                  selectedItem={documentItem}
                                  setSelectItem={setDocumentItem}
                                />
                              </div>
                            )}
                            <div className="w-full">
                              <Input
                                name="doc"
                                errorMessage={errorMessages.doc}
                                value={formValues.doc}
                                disabled={hasPrefilledBitppiField(params?.doc_number)}
                                onChange={(e) => {
                                  setFormValues({
                                    ...formValues,
                                    doc: formatDocument(e),
                                  });
                                }}
                                placeholder={documentNumberPlaceholder}
                                onBlur={() => {
                                  validateInput().docInput();
                                }}
                              />
                            </div>
                          </div>
                        )}
                        <Input
                          type="email"
                          inputMode="email"
                          name="email"
                          value={formValues.email}
                          disabled={hasPrefilledBitppiField(params?.email)}
                          onChange={(value) =>
                            setFormValues({ ...formValues, email: value })
                          }
                          onBlur={() => {
                            validateInput().emailInput();
                          }}
                          errorMessage={errorMessages.email}
                          placeholder={emailPlaceholder}
                          autocomplete="email"
                        />
                        <div className="flex flex-row w-full">
                          <div className={"w-4/6 mr-3"}>
                            <SelectModal
                              items={countries_new}
                              selectedItem={country}
                              setSelectItem={setCountry}
                              customLabelKey="label2"
                              disabled={hasPrefilledBitppiField(params?.country_code)}
                            />
                          </div>
                          <div className="w-full">
                            <Input
                              type="tel"
                              inputMode="tel"
                              autocomplete="tel-national"
                              name="phone"
                              value={formValues.phone}
                              disabled={hasPrefilledBitppiField(params?.phone)}
                              onChange={(e) => {
                                setFormValues({
                                  ...formValues,
                                  phone: formatPhoneNumber(e),
                                });
                              }}
                              errorMessage={errorMessages.phone}
                              placeholder={translate("phone_number_label")}
                              onBlur={() => validateInput().phoneInput()}
                            />
                          </div>
                        </div>
                      </>
                    )}
                    {payMethodName === "cobru" && (
                      <div className="my-5 h-full w-full">
                        {showPhoneCobru ? (
                          <div className="w-full">
                            <Input
                              type="text"
                              name="phone"
                              className="w-full"
                              value={formValues.phone}
                              autocomplete="tel-national"
                              onChange={(e) => {
                                setFormValues({ ...formValues, phone: e });
                              }}
                              placeholder={
                                translate(
                                  "user_text"
                                ) /* !!params && params?.int === 'true' ? 'Phone number': "Número de celular" */
                              }
                              onBlur={() => validateInput().phoneInput()}
                            />
                          </div>
                        ) : payMethodName === 'breb' && !!qrValue && showQr && paymentDetails?.qr_value ?
                          <QRCode_
                            value={qrValue}
                            size={250}
                            logoImage={breb_icon} // aquí pasas la imagen importada
                            logoWidth={100}
                            logoHeight={100}
                            removeQrCodeBehindLogo={true} />
                          : payMethodName !== 'breb' && (

                            <QRCode
                              imageRendering={payMethodName === 'breb' ? breb_icon : null}
                              level="H"
                              size={200}
                              style={{
                                height: "auto",
                                maxWidth: "100%",
                                width: "100%",
                              }}
                              value={qrValue || ""}
                              //value={qrValue || ''}
                              viewBox={`0 0 256 256`}
                            />
                          )}
                        <div className="flex item-center justify-center mt-2">
                          <p>Escanea o </p>
                          <p
                            onClick={() => {
                              setShowPhoneCobru(!showPhoneCobru);
                            }}
                            className="ml-1 underline cursor-pointer	"
                          >
                            {!showPhoneCobru
                              ? translate("type_ur_phone")
                              : translate("go_back_qr")}
                          </p>
                        </div>
                      </div>
                    )}

                    {payMethodName === "pse" ? (
                      <>
                        <SelectModal
                          items={bankList}
                          setSelectItem={setBankPse}
                          selectedItem={bankPse}
                        />
                      </>
                    ) : null}
                    {showRecaptcha && (
                      <div>
                        <ReCAPTCHA
                          sitekey={process.env.REACT_APP_RECAPTCHA_KEY_v2}
                          onChange={handleRecaptchaChange}
                        />
                      </div>
                    )}
                    <p className="text-red-600">{errorMessage}</p>
                    <button
                      disabled={validateDataBasic() || rateLimitSeconds > 0}
                      onClick={() => pay(true)}
                      className={
                        validateDataBasic() || rateLimitSeconds > 0
                          ? "btn-disabled"
                          : isEzy
                            ? "btn-ezy"
                            : isPagaHoy
                              ? "btn-pagahoy"
                              : isTucanPay
                                ? "btn-tucanPay"
                                : isTengo
                                  ? "btn-tengo"
                                : isBitppiAxi
                                  ? "btn-axi"
                                  : isBitppi
                                    ? "btn-bitppi"
                                    : "btn"
                      }
                    >
                      {loading
                        ? translate("loading") + "..."
                        : rateLimitSeconds > 0
                          ? `Reintentar en ${rateLimitSeconds}s`
                          : displayedButtonName}
                    </button>

                    {/* Bre-B usa un solo botón de pago (pay). */}

                    {((!!params && params?.redirect_url) ||
                      (!!cobru && cobru?.payer_redirect_url)) && (
                        <button
                          onClick={() => {
                            let url =
                              !!params && params?.redirect_url
                                ? params?.redirect_url
                                : !!cobru && cobru?.payer_redirect_url
                                  ? cobru?.payer_redirect_url
                                  : "#";
                            if (isEzy) {
                              url = "https://www.ezytransfer.co/";
                            }
                            window.location.href = url.toString();
                            //window.location.href = params?.redirect_url?.toString()
                          }}
                          className={isTengo ? "btn-sec btn-sec-tengo" : "btn-sec"}
                        >
                          {loading
                            ? translate("loading") + "..."
                            : "Volver al comercio"}
                        </button>
                      )}
                  </div>
                )}
                {showOTP && (
                  <div className="grid justify-items-stretch ">
                    {runTimerCheckDaviplata &&
                      payMethodName === "daviplata" /* && !showForm */ ? (
                      <div className="bg-white px-4 py-1 rounded-2xl w-1/5 justify-self-center">
                        <p className="text-center">{countDowDaviplata}</p>
                      </div>
                    ) : null}
                    <Input
                      name="OTP"
                      placeholder="OTP"
                      value={OTPNumber}
                      onChange={(value) => {
                        setOTPNumber(value);
                      }}
                    />
                    <p className="text-red-600">{errorMessage}</p>
                    <button
                      disabled={
                        !countDowDaviplata ||
                        !runTimerCheckDaviplata ||
                        loading ||
                        !OTPNumber ||
                        OTPNumber.length < 6
                      }
                      onClick={() => getDaviplataStatus()}
                      className={
                        !countDowDaviplata ||
                          !runTimerCheckDaviplata ||
                          loading ||
                          !OTPNumber ||
                          OTPNumber.length < 6
                          ? "btn-disabled"
                          : isEzy
                            ? "btn-ezy"
                            : isPagaHoy
                              ? "btn-pagahoy"
                              : isTucanPay
                                ? "btn-tucanPay"
                                : isTengo
                                  ? "btn-tengo"
                                : isBitppiAxi
                                  ? "btn-axi"
                                  : isBitppi
                                    ? "btn-bitppi"
                                    : "btn"
                      }
                    >
                      {loading ? translate("loading") + "..." : displayedButtonName}
                    </button>
                  </div>
                )}
              </div>
            ) : null}
            {/* runTimerCheck && !showForm && payMethodName === 'USDT'
                                ?
                                <p className="price-tag my-4">{currencyAmount} {currencyAmount !== translate('calculating_text') + '...' ? 'USDT' : ''}</p>
                                :
                                null */}
            {/* Loading al regenerar QR (cambio de red USDT/ETH/POLYGON) */}
            {loading && !showForm && !showQr && showUsdtTabs ? (
              <div className="my-6 w-full flex flex-col items-center justify-center">
                <div className="bg-white px-5 py-3 rounded-2xl shadow-sm border border-gray-100">
                  <p className="text-gray-700 font-medium animate-pulse">Generando QR...</p>
                </div>
              </div>
            ) : null}

            {/* Mostrar errores también en la vista de QR/loading (no solo en el formulario) */}
            {!showForm && !!errorMessage ? (
              <div className="w-full flex justify-center mt-3">
                <p className="text-red-600 text-center px-4">{errorMessage}</p>
              </div>
            ) : null}

            {/* 
                            showQr && !showForm && payMethodName === 'NEQUI'
                                ?
                                <div className="flex flex-row items-center justify-center" >
                                    <p className="mr-1">{translate('scan_nequi_text')}</p>

                                </div>
                                :
                                null */}

            {showQr && !showForm && payMethodName !== 'breb' ? (
              <div className="mt-5 mb-0 h-full">
                <QRCode_
                  value={qrValue}
                  size={250}
                  logoImage={
                    payMethodName === "USDT"
                      ? (cryptoNetwork === 'ETH'
                        ? ethLogo
                        : cryptoNetwork === 'POLYGON'
                          ? polygonLogo
                          : tronLogo)
                      : payMethodName === "breb"
                        ? breb_icon
                        : null
                  }
                  logoWidth={60}
                  logoHeight={60}
                  removeQrCodeBehindLogo={true}
                /*  qrStyle="dots" // opcional: estilo de puntos en lugar de cuadros
                  eyeRadius={[
                    { outer: [10, 10, 0, 10], inner: [0, 10, 10, 10] }, // estilo de los ojos
                    { outer: [10, 10, 10, 0], inner: [10, 0, 10, 10] },
                    { outer: [0, 10, 10, 10], inner: [10, 10, 0, 10] }
                  ]} */
                />
                {/*  <QRCode
                    level="H"
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={qrValue}
                    viewBox={`0 0 256 256`}
                  /> */}
              </div>
            ) : null}

            {/* Countdown (debajo del QR) para tabs cripto */}
            {runTimerCheck && showQr && !showForm && payMethodName === "USDT" && cryptoSecondsLeft != null && cryptoSecondsLeft <= 60 ? (
              <div className="bg-white px-4 py-1 rounded-2xl mt-2">
                <p className="text-center">{countDown}</p>
              </div>
            ) : null}


            {showQr && !showForm && payMethodName === "USDT" ? (
              <button
                className="flex flex-row items-center justify-center w-full max-w-md mt-2 py-3 px-4 bg-white rounded-2xl border border-gray-100 shadow-sm"
                style={isBitppiAxi ? { borderColor: AXI_ACCENT } : undefined}
                onClick={handleCopyWallet}
              >
                <p className="mr-2 text-sm font-mono text-gray-700 break-all">
                  {walletCopied ? 'Copiado' : walletPreview}
                </p>
                <div className="bg-gray-50 p-2 ml-2 rounded-full border border-gray-100">
                  <RiFileCopy2Fill style={isBitppiAxi ? { color: AXI_ACCENT } : undefined} />
                </div>
              </button>
            ) : null}
            {payMethodName === "breb" && !successCheck && !showForm && (
              <div className="w-full flex flex-col items-center justify-center mt-4">

                {/* Box 1: QR */}
                {!!paymentDetails?.qr_value && (
                  <div className="w-full max-w-md bg-white rounded-xl shadow-md p-4 border border-gray-100 flex flex-col items-center mt-4">
                    <h3 className="text-gray-800 font-semibold text-base mb-3">
                      Escanea el QR en la app de tu banco
                    </h3>

                    <QRCode_
                      value={paymentDetails?.qr_value}
                      size={250}
                      logoImage={breb_icon}
                      logoWidth={50}
                      logoHeight={50}
                      removeQrCodeBehindLogo={true}
                    />

                    {/* Contador debajo del QR (igual que USDT) */}
                    {runTimerCheckBreb && brebSecondsLeft != null && brebSecondsLeft <= 60 && (
                      <div className="bg-white px-4 py-1 rounded-2xl mt-2">
                        <p className="text-center">{countDown}</p>
                      </div>
                    )}
                  </div>
                )}

                {/* Box 2: Llave */}
                {!!paymentDetails?.key_value && (
                  <div className="w-full max-w-md bg-white rounded-xl shadow-md p-4 border border-gray-100 flex flex-col items-center mt-4">
                    <div className="flex flex-row items-center justify-start w-full mt-2">
                      <button
                        onClick={() => copyClipbord(paymentDetails?.key_value, () => showToast())}
                        className="flex flex-row items-center justify-between bg-gray-50 hover:bg-gray-100 transition-colors rounded-full px-4 py-2 w-full"
                      >
                        <span className="text-sm font-mono text-gray-700 break-all">
                          {paymentDetails?.key_value}
                        </span>

                        <div className="bg-white p-2 rounded-full shadow-sm hover:scale-105 transition-transform">
                          <RiFileCopy2Fill className="text-gray-600 text-lg" />
                        </div>
                      </button>
                    </div>
                  </div>
                )}

              </div>
            )}
            {/* {payMethodName === "breb" && paymentDetails?.key_value && !isOn ? (
              <div className="flex flex-row items-center justify-start">

                <a className="mr-3">LLave Bre-b:</a>
                <button
                  className="flex flex-row items-center justify-center"
                  onClick={() => copyClipbord(paymentDetails?.key_value)}
                >
                  <p className="mr-1">
                    {paymentDetails?.key_value?.substring(0, 5) +
                      "..." +
                      paymentDetails?.key_value?.substring(paymentDetails?.key_value.length - 3, paymentDetails?.key_value?.length)}
                  </p>
                  <div className="bg-white p-2 mx-2 rounded-full">
                    <RiFileCopy2Fill />
                  </div>
                </button>
              </div>
            ) : null}
            {payMethodName === "breb" && paymentDetails?.key_value && !showQr && !successCheck && !showForm && (
              <>
                <h3 className="text-gray-800 font-semibold text-base mb-2">
                  Coloca el monto y la llave en la app de tu banco
                </h3>
                {runTimerCheckBreb &&
                  /* && !showForm /  (
                    <div className="bg-white px-4 py-1 rounded-2xl w-1/5 justify-self-center mt-3 mb-3">
                      <p className="text-center">{countDown}</p>
                    </div>
                  )}
                <div className="w-full max-w-md bg-white rounded-xl shadow-md p-4 border border-gray-100 flex flex-col items-start">

                  <h3 className="text-gray-800 font-semibold text-base mt-2">
                    Monto
                  </h3>
                  <div className="flex flex-row items-center justify-start w-full mt-2">
                    <button
                      onClick={() => copyClipbord(getDigits(amount), () => showToast())}
                      className="flex flex-row items-center justify-between bg-gray-50 hover:bg-gray-100 transition-colors rounded-full px-4 py-2 w-full"
                    >
                      <span className="text-sm font-mono text-gray-700">
                        {amount}
                      </span>

                      <div className="bg-white p-2 rounded-full shadow-sm hover:scale-105 transition-transform">
                        <RiFileCopy2Fill className="text-gray-600 text-lg" />
                      </div>
                    </button>
                  </div>
                  <h3 className="text-gray-800 font-semibold text-base mt-2">
                    🔑 Llave Bre-b
                  </h3>

                  <div className="flex flex-row items-center justify-start w-full mt-2">
                    <button
                      onClick={() => copyClipbord(paymentDetails?.key_value, () => showToast())}
                      className="flex flex-row items-center justify-between bg-gray-50 hover:bg-gray-100 transition-colors rounded-full px-4 py-2 w-full"
                    >
                      <span className="text-sm font-mono text-gray-700">
                        {paymentDetails?.key_value/* ?.substring(0, 5) +
                          "..." +
                          paymentDetails?.key_value?.substring(
                            paymentDetails?.key_value.length - 3,
                            paymentDetails?.key_value?.length
                          ) /}
                      </span>

                      <div className="bg-white p-2 rounded-full shadow-sm hover:scale-105 transition-transform">
                        <RiFileCopy2Fill className="text-gray-600 text-lg" />
                      </div>
                    </button>
                  </div>
                </div>

              </>

            )} */}

            {waitingNequiPay && !showForm ? (
              <div className="w-full h-full flex justify-center items-center flex-col py-5">
                <Loading />
                <p className="text-center">
                  {translate("nequi_notification_center_text")}
                  <br /> O
                  <a
                    className="underline cursor-pointer"
                    onClick={() => {
                      pay(false);
                    }}
                  >
                    {translate("pay_with_qr")}
                  </a>
                </p>
              </div>
            ) : null}
            {showPin && !showForm ? (
              <>
                <PinPayInfo
                  TitleText1={
                    payMethodName === "efecty"
                      ? translate("project_label") + ":"
                      : translate("agreement_label") + ":"
                  }
                  text1={payPin.code}
                  TitleText2={
                    payMethodName === "efecty"
                      ? "PIN:"
                      : translate("reference_label") + ":"
                  }
                  text2={payPin.ref}
                  exp={expDate}
                  info={getIndicatiosPin()}
                />
              </>
            ) : null}

            {successCheck && !showForm ? (
              <>
                <div className="my-2" />

                {receiptReference && (
                  <p className="mt-1">
                    REF-{receiptReference}
                  </p>
                )}
                <h2 className="text-3xl font-bold">
                  {translate("successful_payment")}
                </h2>
                <img src={checkIcon} className="w-24 my-6" />
                <div className="w-full border-gray-300 border bg-white p-4">
                  {payMethodName === "daviplata" && daviplataInfo && (
                    <div className="w-full flex justify-between my-1 ">
                      <p>{translate("authorization")}</p>
                      <p>{daviplataInfo}</p>
                    </div>
                  )}
                  <div className="w-full flex justify-between my-1 ">
                    <p>{translate("date_and_time")}</p>
                    <p>{moment().format("MM-DD-YYYY h:mm a")}</p>
                  </div>
                  {/*  <div className="w-full flex justify-between my-1 ">
                                            <p>{translate('fee')}</p>
                                            <p>{formatCOPNumber(parseInt(paymentDetailsCobru.fee_amount))}</p>
                                        </div>
                                        <div className="w-full flex justify-between my-1 ">
                                            <p>{translate('fee_iva')}</p>
                                            <p>{formatCOPNumber(parseInt(paymentDetailsCobru.fee_iva_amount))}</p>
                                        </div> */}
                  <div className="w-full flex justify-between my-1 ">
                    <p>{translate("amount")}</p>
                    <p>
                      {formatCOPNumber(
                        parseInt(
                            /* paymentDetailsCobru.payed_amount ||  */ paymentDetails?.amount
                        )
                      )}
                    </p>
                  </div>
                  {
                    payMethodName === 'USDT' &&
                    <div className="w-full flex justify-between my-1 ">
                      <p>{`${translate("amount")} ${cryptoQuoteCurrency}`}</p>
                      <p>
                        {cryptoReceiptAmount}
                      </p>
                    </div>
                  }
                  {
                    payMethodName === 'USDT' &&
                    <div className="w-full flex justify-between items-start my-1 gap-2">
                      <p className="shrink-0">Billetera</p>
                      <p className="text-right break-all max-w-[65%]">
                        {paymentDetails?.qr_bitcoin}
                      </p>
                    </div>
                  }
                </div>
                <p className="pt-1">
                  {paymentDetails?.ip + " " + getNavInfo().browserName}
                </p>
                <div className="my-2" />
              </>
            ) : null}
            <div className="m-3" />
          </div>
          <div className="h-14 w-full">
            <hr />
            <div className="first-child flex flex-row justify-between py-5 ">
              <div className="flex flex-col justify-center">
                <span className="text-xs text-zinc-400 font-normal">
                  {
                    translate(
                      "more_info"
                    ) /* !!params && params?.int === 'true'? 'More information':'Más información' */
                  }
                </span>
                <p className="font-bold text-lg text-neutral-600">
                  {cobru ? cobru?.alias : ""}
                </p>
              </div>
              <div className="flex flex-row items-center">
                <div className="bg-white p-2 mx-2 rounded-full">
                  <PhoneContact cobruInfo={cobru} />
                  {/* <a href={cobru?.phone && cobru?.country_code ? `tel:${cobru?.country_code}${cobru?.phone}` : cobru?.phone && cobru?.country_code ? `tel:${cobru?.phone}` : ""}>
                                        <BsTelephoneFill />
                                    </a> */}
                </div>
                <div className="bg-white p-2 rounded-full">
                  {/*  <a href={cobru?.owner_email ? `mailto:${cobru?.owner_email}` : ''}>
                                        <MdMail />
                                    </a> */}
                  <EmailContact cobruInfo={cobru} />
                </div>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
      {/* 
            <p className="text-left">URL</p>
                        {
                cobruURL &&
                <p className="text-left">{cobruURL}</p>
            }

            <p className="text-left">{showCobru.toString()}</p>
 */}
    </div>
  );
}

export default Home; 
